var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _mask, _path17, _path18, _mask2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _mask3, _path35, _path36, _path37, _path38, _mask4, _path39, _path40, _mask5, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _mask6, _path72, _path73, _path74, _mask7, _path75, _path76, _mask8, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _mask9, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _mask10, _path117, _path118, _path119, _mask11, _path120, _path121, _mask12, _path122, _path123, _path124, _mask13, _path125, _path126, _mask14, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _mask15, _path180, _path181, _mask16, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _mask17, _path204, _path205, _mask18, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _mask19, _path216, _path217, _mask20, _path218, _path219, _mask21, _path220, _path221, _mask22, _path222, _path223, _path224, _mask23, _path225, _path226, _mask24, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _mask25, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _mask26, _path269, _path270, _mask27, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _mask28, _path421, _path422, _mask29, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarbleWorldContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1201,
    height: 800,
    viewBox: "0 0 1201 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.72559,
    y: 1,
    width: 1198,
    height: 798,
    fill: "#1E1E1E",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903.038 494.344L862.516 474.489L821.993 494.344L862.516 515.925L903.038 494.344Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M945.619 471.722L905.216 451.823L864.772 473.474L905.175 493.373L945.619 471.722Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M904.192 520.075V495.975L863.515 517.639V541.739L904.192 520.075Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M946.87 497.345V473.245L906.193 494.909V519.009L946.87 497.345Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M820.838 520.075V495.975L861.515 517.639V541.739L820.838 520.075Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M903.038 467.069L862.516 447.214L821.993 467.069L862.516 488.65L903.038 467.069Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M945.619 444.446L905.216 424.547L864.772 446.199L905.175 466.098L945.619 444.446Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M904.192 492.8V468.7L863.515 490.364V514.464L904.192 492.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M946.87 470.07V445.97L906.193 467.634V491.734L946.87 470.07Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M820.838 492.8V468.7L861.515 490.364V514.464L820.838 492.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M780.286 517.982L820.809 498.127L861.331 517.982L820.809 539.563L780.286 517.982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M779.131 543.713V519.613L819.808 541.277V565.377L779.131 543.713Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M862.486 543.713V519.613L821.809 541.277V565.377L862.486 543.713Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M737.704 495.36L778.107 475.46L818.551 497.112L778.148 517.011L737.704 495.36Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M736.453 520.983V496.883L777.131 518.548V542.648L736.453 520.983Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.758 747.356V723.256L95.0803 744.92V769.021L135.758 747.356Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9159 700.76L51.4016 678L8.82812 698.968L51.4016 721.759L51.5675 721.678L94.0805 744.319L136.758 721.59L94.0805 700.679L93.9159 700.76Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9159 700.76L51.4016 678L8.82812 698.968L51.4016 721.759L51.5675 721.678L94.0805 744.319L136.758 721.59L94.0805 700.679L93.9159 700.76Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4016 678L52.3455 676.237L51.4397 675.752L50.5179 676.206L51.4016 678ZM93.9159 700.76L92.972 702.523L93.8755 703.007L94.7959 702.556L93.9159 700.76ZM8.82812 698.968L7.94446 697.174L4.45204 698.894L7.8842 700.731L8.82812 698.968ZM51.4016 721.759L50.4577 723.522L51.3635 724.007L52.2853 723.553L51.4016 721.759ZM51.5675 721.678L52.5076 719.912L51.6031 719.431L50.6838 719.883L51.5675 721.678ZM94.0805 744.319L93.1404 746.085L94.0805 746.585L95.0206 746.085L94.0805 744.319ZM136.758 721.59L137.698 723.355L141.152 721.516L137.638 719.794L136.758 721.59ZM94.0805 700.679L94.9605 698.883L94.0805 698.452L93.2005 698.883L94.0805 700.679ZM50.4577 679.763L92.972 702.523L94.8598 698.996L52.3455 676.237L50.4577 679.763ZM9.71179 700.762L52.2853 679.794L50.5179 676.206L7.94446 697.174L9.71179 700.762ZM52.3455 719.996L9.77205 697.205L7.8842 700.731L50.4577 723.522L52.3455 719.996ZM50.6838 719.883L50.5179 719.965L52.2853 723.553L52.4511 723.472L50.6838 719.883ZM95.0206 742.554L52.5076 719.912L50.6273 723.443L93.1404 746.085L95.0206 742.554ZM135.818 719.825L93.1404 742.554L95.0206 746.085L137.698 723.355L135.818 719.825ZM93.2005 702.475L135.878 723.386L137.638 719.794L94.9605 698.883L93.2005 702.475ZM94.7959 702.556L94.9605 702.475L93.2005 698.883L93.0359 698.964L94.7959 702.556Z",
    fill: "black",
    mask: "url(#path-18-inside-1_3131_11627)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-2_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4031 721.591L8.72559 698.861V725.227L51.4031 747.957V721.591ZM94.0808 744.32L51.4033 721.591V747.957L94.0808 770.686V744.32Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4031 721.591L8.72559 698.861V725.227L51.4031 747.957V721.591ZM94.0808 744.32L51.4033 721.591V747.957L94.0808 770.686V744.32Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72559 698.861L9.66573 697.096L6.72559 695.53V698.861H8.72559ZM51.4031 721.591H53.4031V720.39L52.3432 719.826L51.4031 721.591ZM8.72559 725.227H6.72559V726.428L7.78544 726.993L8.72559 725.227ZM51.4031 747.957L50.4629 749.722L53.4031 751.288V747.957H51.4031ZM51.4033 721.591L52.3435 719.825L49.4033 718.26V721.591H51.4033ZM94.0808 744.32H96.0808V743.119L95.021 742.555L94.0808 744.32ZM51.4033 747.957H49.4033V749.158L50.4632 749.722L51.4033 747.957ZM94.0808 770.686L93.1407 772.451L96.0808 774.017V770.686H94.0808ZM7.78544 700.627L50.4629 723.356L52.3432 719.826L9.66573 697.096L7.78544 700.627ZM10.7256 725.227V698.861H6.72559V725.227H10.7256ZM52.3432 746.192L9.66573 723.462L7.78544 726.993L50.4629 749.722L52.3432 746.192ZM49.4031 721.591V747.957H53.4031V721.591H49.4031ZM50.4632 723.356L93.1407 746.085L95.021 742.555L52.3435 719.825L50.4632 723.356ZM53.4033 747.957V721.591H49.4033V747.957H53.4033ZM95.021 768.921L52.3435 746.191L50.4632 749.722L93.1407 772.451L95.021 768.921ZM92.0808 744.32V770.686H96.0808V744.32H92.0808Z",
    fill: "black",
    mask: "url(#path-20-inside-2_3131_11627)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M736.738 468.088L777.161 448.179L817.585 468.088L777.161 489.728L736.738 468.088Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M735.483 493.709V469.609L776.161 491.273V515.373L735.483 493.709Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M818.838 493.709V469.609L778.16 491.273V515.373L818.838 493.709Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M907.98 494.148L948.403 474.239L988.827 494.148L948.403 515.789L907.98 494.148Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M906.726 519.769V495.669L947.403 517.333V541.433L906.726 519.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M990.08 519.769V495.669L949.403 517.333V541.433L990.08 519.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.98 722.148L1147.4 702.239L1187.83 722.148L1147.4 743.789L1106.98 722.148Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.73 747.769V723.669L1146.4 745.333V769.433L1105.73 747.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.08 747.769V723.669L1148.4 745.333V769.433L1189.08 747.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M908.417 466.269L948.841 446.36L989.264 466.269L948.841 487.909L908.417 466.269Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M907.163 491.89V467.79L947.841 489.454V513.554L907.163 491.89Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M990.518 491.89V467.79L949.84 489.454V513.554L990.518 491.89Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M904.193 464.616V440.515L863.516 462.18V486.28L904.193 464.616Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M820.838 464.616V440.515L861.515 462.18V486.28L820.838 464.616Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-3_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.68 418.019L905.195 395.259L947.769 416.227L905.195 439.018L905.03 438.937L862.516 461.579L819.839 438.849L862.516 417.938L862.68 418.019Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.68 418.019L905.195 395.259L947.769 416.227L905.195 439.018L905.03 438.937L862.516 461.579L819.839 438.849L862.516 417.938L862.68 418.019Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M905.195 395.259L904.251 393.496L905.157 393.011L906.079 393.465L905.195 395.259ZM862.68 418.019L863.624 419.782L862.721 420.266L861.8 419.815L862.68 418.019ZM947.769 416.227L948.652 414.433L952.145 416.153L948.712 417.99L947.769 416.227ZM905.195 439.018L906.139 440.781L905.233 441.266L904.311 440.812L905.195 439.018ZM905.03 438.937L904.09 437.171L904.994 436.69L905.913 437.142L905.03 438.937ZM862.516 461.579L863.456 463.344L862.516 463.845L861.576 463.344L862.516 461.579ZM819.839 438.849L818.899 440.614L815.445 438.775L818.959 437.053L819.839 438.849ZM862.516 417.938L861.636 416.142L862.516 415.711L863.396 416.142L862.516 417.938ZM906.139 397.022L863.624 419.782L861.736 416.255L904.251 393.496L906.139 397.022ZM946.885 418.021L904.311 397.053L906.079 393.465L948.652 414.433L946.885 418.021ZM904.251 437.255L946.825 414.464L948.712 417.99L906.139 440.781L904.251 437.255ZM905.913 437.142L906.079 437.224L904.311 440.812L904.146 440.731L905.913 437.142ZM861.576 459.813L904.09 437.171L905.97 440.702L863.456 463.344L861.576 459.813ZM820.779 437.084L863.456 459.813L861.576 463.344L818.899 440.614L820.779 437.084ZM863.396 419.734L820.719 440.645L818.959 437.053L861.636 416.142L863.396 419.734ZM861.8 419.815L861.636 419.734L863.396 416.142L863.56 416.223L861.8 419.815Z",
    fill: "black",
    mask: "url(#path-36-inside-3_3131_11627)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M946.871 441.886V417.786L906.194 439.45V463.55L946.871 441.886Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M820.727 565.59V541.489L861.404 563.154V587.254L820.727 565.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-4_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.568 518.993L905.084 496.233L947.657 517.201L905.084 539.992L904.918 539.91L862.403 562.553L819.725 539.824L862.403 518.913L862.568 518.993Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.568 518.993L905.084 496.233L947.657 517.201L905.084 539.992L904.918 539.91L862.403 562.553L819.725 539.824L862.403 518.913L862.568 518.993Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M905.084 496.233L904.14 494.47L905.046 493.985L905.967 494.439L905.084 496.233ZM862.568 518.993L863.512 520.757L862.608 521.24L861.688 520.789L862.568 518.993ZM947.657 517.201L948.541 515.407L952.033 517.127L948.601 518.964L947.657 517.201ZM905.084 539.992L906.028 541.755L905.122 542.24L904.2 541.786L905.084 539.992ZM904.918 539.91L903.977 538.145L904.882 537.663L905.801 538.116L904.918 539.91ZM862.403 562.553L863.343 564.318L862.403 564.819L861.463 564.318L862.403 562.553ZM819.725 539.824L818.785 541.589L815.331 539.749L818.845 538.028L819.725 539.824ZM862.403 518.913L861.523 517.117L862.403 516.685L863.283 517.117L862.403 518.913ZM906.028 497.996L863.512 520.757L861.624 517.23L904.14 494.47L906.028 497.996ZM946.774 518.995L904.2 498.027L905.967 494.439L948.541 515.407L946.774 518.995ZM904.14 538.229L946.713 515.438L948.601 518.964L906.028 541.755L904.14 538.229ZM905.801 538.116L905.967 538.198L904.2 541.786L904.034 541.705L905.801 538.116ZM861.463 560.788L903.977 538.145L905.858 541.676L863.343 564.318L861.463 560.788ZM820.666 538.058L863.343 560.788L861.463 564.318L818.785 541.589L820.666 538.058ZM863.283 520.709L820.605 541.62L818.845 538.028L861.523 517.117L863.283 520.709ZM861.688 520.789L861.523 520.709L863.283 517.117L863.448 517.197L861.688 520.789Z",
    fill: "black",
    mask: "url(#path-40-inside-4_3131_11627)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-5_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.081 539.824L947.759 517.094V543.461L905.081 566.19V539.824ZM862.404 562.553L905.081 539.824V566.19L862.404 588.919V562.553Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.081 539.824L947.759 517.094V543.461L905.081 566.19V539.824ZM862.404 562.553L905.081 539.824V566.19L862.404 588.919V562.553Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M947.759 517.094L946.819 515.329L949.759 513.763V517.094H947.759ZM905.081 539.824H903.081V538.623L904.141 538.059L905.081 539.824ZM947.759 543.461H949.759V544.661L948.699 545.226L947.759 543.461ZM905.081 566.19L906.021 567.955L903.081 569.521V566.19H905.081ZM905.081 539.824L904.141 538.058L907.081 536.493V539.824H905.081ZM862.404 562.553H860.404V561.352L861.463 560.788L862.404 562.553ZM905.081 566.19H907.081V567.391L906.021 567.955L905.081 566.19ZM862.404 588.919L863.344 590.684L860.404 592.25V588.919H862.404ZM948.699 518.86L906.021 541.589L904.141 538.059L946.819 515.329L948.699 518.86ZM945.759 543.461V517.094H949.759V543.461H945.759ZM904.141 564.425L946.819 541.695L948.699 545.226L906.021 567.955L904.141 564.425ZM907.081 539.824V566.19H903.081V539.824H907.081ZM906.021 541.589L863.344 564.318L861.463 560.788L904.141 538.058L906.021 541.589ZM903.081 566.19V539.824H907.081V566.19H903.081ZM861.463 587.154L904.141 564.425L906.021 567.955L863.344 590.684L861.463 587.154ZM864.404 562.553V588.919H860.404V562.553H864.404Z",
    fill: "black",
    mask: "url(#path-42-inside-5_3131_11627)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M908.417 438.085L948.841 418.176L989.264 438.085L948.841 459.725L908.417 438.085Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M907.163 463.706V439.606L947.841 461.27V485.37L907.163 463.706Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M990.518 463.706V439.606L949.84 461.27V485.37L990.518 463.706Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M908.98 409.463L949.403 389.554L989.827 409.463L949.403 431.103L908.98 409.463Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M907.726 435.084V410.984L948.403 432.648V456.748L907.726 435.084Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M991.08 435.084V410.984L950.403 432.648V456.748L991.08 435.084Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9196 745.116L137.403 723.613L177.887 745.116L137.403 766.789L96.9196 745.116Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7256 770.769V746.669L136.403 768.333V792.433L95.7256 770.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M179.08 770.769V746.669L138.403 768.333V792.433L179.08 770.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M908.98 380.406L949.403 360.497L989.827 380.406L949.403 402.046L908.98 380.406Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M907.726 406.027V381.927L948.403 403.591V427.691L907.726 406.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M991.08 406.027V381.927L950.403 403.591V427.691L991.08 406.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M409.077 723.733L449.501 703.824L489.925 723.733L449.501 745.373L409.077 723.733Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M407.823 749.354V725.254L448.501 746.918V771.018L407.823 749.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M491.178 749.354V725.254L450.5 746.918V771.018L491.178 749.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 351.731L949.532 331.822L989.956 351.731L949.532 373.372L909.109 351.731Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 377.352V353.252L948.532 374.916V399.016L907.854 377.352Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 377.352V353.252L950.531 374.916V399.016L991.209 377.352Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M409.077 695.549L449.501 675.64L489.925 695.549L449.501 717.189L409.077 695.549Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.823 721.17V697.07L448.501 718.734V742.834L407.823 721.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M491.178 721.17V697.07L450.5 718.734V742.834L491.178 721.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M692.991 518.891L733.514 499.036L774.036 518.891L733.514 540.473L692.991 518.891Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M691.836 544.622V520.522L732.513 542.186V566.286L691.836 544.622Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M775.191 544.622V520.522L734.514 542.186V566.286L775.191 544.622Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M650.409 496.269L690.812 476.37L731.256 498.021L690.853 517.92L650.409 496.269Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M649.158 521.892V497.792L689.836 519.456V543.556L649.158 521.892Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M648.374 542.53L688.896 522.675L729.419 542.53L688.896 564.111L648.374 542.53Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M730.574 568.261V544.161L689.897 565.825V589.925L730.574 568.261Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M605.792 519.907L646.195 500.008L686.639 521.66L646.236 541.559L605.792 519.907Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-6_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.219 542.495L603.541 519.766V546.132L646.219 568.861V542.495ZM688.896 565.224L646.219 542.495V568.861L688.896 591.591V565.224Z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.219 542.495L603.541 519.766V546.132L646.219 568.861V542.495ZM688.896 565.224L646.219 542.495V568.861L688.896 591.591V565.224Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M603.541 519.766L604.481 518.001L601.541 516.435V519.766H603.541ZM646.219 542.495H648.219V541.294L647.159 540.73L646.219 542.495ZM603.541 546.132H601.541V547.333L602.601 547.897L603.541 546.132ZM646.219 568.861L645.278 570.627L648.219 572.192V568.861H646.219ZM646.219 542.495L647.159 540.73L644.219 539.164V542.495H646.219ZM688.896 565.224H690.896V564.024L689.836 563.459L688.896 565.224ZM646.219 568.861H644.219V570.062L645.279 570.626L646.219 568.861ZM688.896 591.591L687.956 593.356L690.896 594.922V591.591H688.896ZM602.601 521.531L645.278 544.26L647.159 540.73L604.481 518.001L602.601 521.531ZM605.541 546.132V519.766H601.541V546.132H605.541ZM647.159 567.096L604.481 544.367L602.601 547.897L645.278 570.627L647.159 567.096ZM644.219 542.495V568.861H648.219V542.495H644.219ZM645.279 544.26L687.956 566.99L689.836 563.459L647.159 540.73L645.279 544.26ZM648.219 568.861V542.495H644.219V568.861H648.219ZM689.836 589.825L647.159 567.096L645.279 570.626L687.956 593.356L689.836 589.825ZM686.896 565.224V591.591H690.896V565.224H686.896Z",
    fill: "black",
    mask: "url(#path-73-inside-6_3131_11627)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.76 771.59V747.49L1105.08 769.154V793.254L1145.76 771.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-7_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.92 724.993L1061.4 702.233L1018.83 723.201L1061.4 745.992L1061.57 745.91L1104.08 768.553L1146.76 745.824L1104.08 724.913L1103.92 724.993Z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.92 724.993L1061.4 702.233L1018.83 723.201L1061.4 745.992L1061.57 745.91L1104.08 768.553L1146.76 745.824L1104.08 724.913L1103.92 724.993Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.4 702.233L1062.34 700.47L1061.44 699.985L1060.52 700.439L1061.4 702.233ZM1103.92 724.993L1102.97 726.757L1103.88 727.24L1104.8 726.789L1103.92 724.993ZM1018.83 723.201L1017.94 721.407L1014.45 723.127L1017.88 724.964L1018.83 723.201ZM1061.4 745.992L1060.46 747.755L1061.36 748.24L1062.28 747.786L1061.4 745.992ZM1061.57 745.91L1062.51 744.145L1061.6 743.663L1060.68 744.116L1061.57 745.91ZM1104.08 768.553L1103.14 770.318L1104.08 770.819L1105.02 770.318L1104.08 768.553ZM1146.76 745.824L1147.7 747.589L1151.15 745.749L1147.64 744.028L1146.76 745.824ZM1104.08 724.913L1104.96 723.117L1104.08 722.685L1103.2 723.117L1104.08 724.913ZM1060.46 703.996L1102.97 726.757L1104.86 723.23L1062.34 700.47L1060.46 703.996ZM1019.71 724.995L1062.28 704.027L1060.52 700.439L1017.94 721.407L1019.71 724.995ZM1062.34 744.229L1019.77 721.438L1017.88 724.964L1060.46 747.755L1062.34 744.229ZM1060.68 744.116L1060.52 744.198L1062.28 747.786L1062.45 747.705L1060.68 744.116ZM1105.02 766.788L1062.51 744.145L1060.63 747.676L1103.14 770.318L1105.02 766.788ZM1145.82 744.058L1103.14 766.788L1105.02 770.318L1147.7 747.589L1145.82 744.058ZM1103.2 726.709L1145.88 747.62L1147.64 744.028L1104.96 723.117L1103.2 726.709ZM1104.8 726.789L1104.96 726.709L1103.2 723.117L1103.04 723.197L1104.8 726.789Z",
    fill: "black",
    mask: "url(#path-76-inside-7_3131_11627)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-78-inside-8_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.4 745.824L1018.73 723.095V749.461L1061.4 772.19V745.824ZM1104.08 768.553L1061.4 745.824V772.19L1104.08 794.919V768.553Z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.4 745.824L1018.73 723.095V749.461L1061.4 772.19V745.824ZM1104.08 768.553L1061.4 745.824V772.19L1104.08 794.919V768.553Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.73 723.095L1019.67 721.33L1016.73 719.764V723.095H1018.73ZM1061.4 745.824H1063.4V744.623L1062.34 744.059L1061.4 745.824ZM1018.73 749.461H1016.73V750.662L1017.79 751.226L1018.73 749.461ZM1061.4 772.19L1060.46 773.956L1063.4 775.521V772.19H1061.4ZM1061.4 745.824L1062.34 744.059L1059.4 742.493V745.824H1061.4ZM1104.08 768.553H1106.08V767.353L1105.02 766.788L1104.08 768.553ZM1061.4 772.19H1059.4V773.391L1060.46 773.955L1061.4 772.19ZM1104.08 794.919L1103.14 796.685L1106.08 798.251V794.919H1104.08ZM1017.79 724.86L1060.46 747.589L1062.34 744.059L1019.67 721.33L1017.79 724.86ZM1020.73 749.461V723.095H1016.73V749.461H1020.73ZM1062.34 770.425L1019.67 747.696L1017.79 751.226L1060.46 773.956L1062.34 770.425ZM1059.4 745.824V772.19H1063.4V745.824H1059.4ZM1060.46 747.589L1103.14 770.319L1105.02 766.788L1062.34 744.059L1060.46 747.589ZM1063.4 772.19V745.824H1059.4V772.19H1063.4ZM1105.02 793.154L1062.34 770.425L1060.46 773.955L1103.14 796.685L1105.02 793.154ZM1102.08 768.553V794.919H1106.08V768.553H1102.08Z",
    fill: "black",
    mask: "url(#path-78-inside-8_3131_11627)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M692.991 490.707L733.514 470.852L774.036 490.707L733.514 512.288L692.991 490.707Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M650.409 468.085L690.812 448.186L731.256 469.837L690.853 489.736L650.409 468.085Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M691.836 516.438V492.338L732.513 514.002V538.102L691.836 516.438Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M649.158 493.708V469.608L689.836 491.272V515.373L649.158 493.708Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M775.191 516.438V492.338L734.514 514.002V538.102L775.191 516.438Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M754.852 484.399C756.849 484.399 758.608 484.875 759.834 485.593C761.083 486.325 761.612 487.191 761.612 487.945V493.4C761.612 494.154 761.083 495.019 759.834 495.751C758.608 496.47 756.849 496.946 754.852 496.946C752.856 496.946 751.097 496.47 749.871 495.751C748.622 495.019 748.093 494.154 748.093 493.4V487.945C748.093 487.191 748.622 486.325 749.871 485.593C751.097 484.875 752.856 484.399 754.852 484.399Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M712.175 461.67C714.171 461.67 715.93 462.146 717.156 462.864C718.405 463.596 718.934 464.462 718.934 465.216V470.671C718.934 471.425 718.405 472.29 717.156 473.022C715.93 473.74 714.171 474.216 712.175 474.216C710.178 474.216 708.419 473.74 707.193 473.022C705.944 472.29 705.415 471.425 705.415 470.671V465.216C705.415 464.462 705.944 463.596 707.193 462.864C708.419 462.146 710.178 461.67 712.175 461.67Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M712.175 484.399C714.171 484.399 715.93 484.875 717.156 485.593C718.405 486.325 718.934 487.191 718.934 487.945V493.4C718.934 494.154 718.405 495.019 717.156 495.751C715.93 496.47 714.171 496.946 712.175 496.946C710.178 496.946 708.419 496.47 707.193 495.751C705.944 495.019 705.415 494.154 705.415 493.4V487.945C705.415 487.191 705.944 486.325 707.193 485.593C708.419 484.875 710.178 484.399 712.175 484.399Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M669.497 461.67C671.494 461.67 673.252 462.146 674.478 462.864C675.728 463.596 676.256 464.462 676.256 465.216V470.671C676.256 471.425 675.728 472.29 674.478 473.022C673.252 473.74 671.494 474.216 669.497 474.216C667.5 474.216 665.741 473.74 664.516 473.022C663.266 472.29 662.737 471.425 662.737 470.671V465.216C662.737 464.462 663.266 463.596 664.516 462.864C665.741 462.146 667.5 461.67 669.497 461.67Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M733.513 495.309C735.51 495.309 737.269 495.785 738.495 496.503C739.744 497.235 740.273 498.1 740.273 498.854V504.31C740.273 505.064 739.744 505.929 738.495 506.661C737.269 507.379 735.51 507.855 733.513 507.855C731.517 507.855 729.758 507.379 728.532 506.661C727.283 505.929 726.754 505.064 726.754 504.31V498.854C726.754 498.1 727.283 497.235 728.532 496.503C729.758 495.785 731.517 495.309 733.513 495.309Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M690.836 472.579C692.832 472.579 694.591 473.056 695.817 473.774C697.067 474.506 697.595 475.371 697.595 476.125V481.58C697.595 482.334 697.067 483.2 695.817 483.932C694.591 484.65 692.832 485.126 690.836 485.126C688.839 485.126 687.08 484.65 685.854 483.932C684.605 483.2 684.076 482.334 684.076 481.58V476.125C684.076 475.371 684.605 474.506 685.854 473.774C687.08 473.056 688.839 472.579 690.836 472.579Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M733.513 474.398C735.51 474.398 737.269 474.874 738.495 475.592C739.744 476.324 740.273 477.19 740.273 477.944V483.399C740.273 484.153 739.744 485.018 738.495 485.751C737.269 486.469 735.51 486.945 733.513 486.945C731.517 486.945 729.758 486.469 728.532 485.751C727.283 485.018 726.754 484.153 726.754 483.399V477.944C726.754 477.19 727.283 476.324 728.532 475.592C729.758 474.874 731.517 474.398 733.513 474.398Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M690.836 451.668C692.832 451.668 694.591 452.144 695.817 452.862C697.067 453.594 697.595 454.46 697.595 455.214V460.669C697.595 461.423 697.067 462.288 695.817 463.02C694.591 463.738 692.832 464.215 690.836 464.215C688.839 464.215 687.08 463.738 685.854 463.02C684.605 462.288 684.076 461.423 684.076 460.669V455.214C684.076 454.46 684.605 453.594 685.854 452.862C687.08 452.144 688.839 451.668 690.836 451.668Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M760.642 487.944C760.642 488.402 760.28 489.046 759.181 489.634C758.124 490.2 756.595 490.581 754.852 490.581C753.109 490.581 751.58 490.2 750.523 489.634C749.425 489.046 749.062 488.402 749.062 487.944C749.062 487.487 749.425 486.843 750.523 486.254C751.58 485.688 753.109 485.308 754.852 485.308C756.595 485.308 758.124 485.688 759.181 486.254C760.28 486.843 760.642 487.487 760.642 487.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M717.964 465.216C717.964 465.673 717.602 466.317 716.503 466.906C715.446 467.472 713.918 467.852 712.174 467.852C710.431 467.852 708.902 467.472 707.846 466.906C706.747 466.317 706.385 465.673 706.385 465.216C706.385 464.758 706.747 464.114 707.846 463.526C708.902 462.959 710.431 462.579 712.174 462.579C713.918 462.579 715.446 462.959 716.503 463.526C717.602 464.114 717.964 464.758 717.964 465.216Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M717.964 487.944C717.964 488.402 717.602 489.046 716.503 489.634C715.446 490.2 713.918 490.581 712.174 490.581C710.431 490.581 708.902 490.2 707.846 489.634C706.747 489.046 706.385 488.402 706.385 487.944C706.385 487.487 706.747 486.843 707.846 486.254C708.902 485.688 710.431 485.308 712.174 485.308C713.918 485.308 715.446 485.688 716.503 486.254C717.602 486.843 717.964 487.487 717.964 487.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M675.286 465.216C675.286 465.673 674.924 466.317 673.825 466.906C672.769 467.472 671.24 467.852 669.497 467.852C667.753 467.852 666.225 467.472 665.168 466.906C664.069 466.317 663.707 465.673 663.707 465.216C663.707 464.758 664.069 464.114 665.168 463.526C666.225 462.959 667.753 462.579 669.497 462.579C671.24 462.579 672.769 462.959 673.825 463.526C674.924 464.114 675.286 464.758 675.286 465.216Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M739.303 498.854C739.303 499.312 738.941 499.956 737.842 500.544C736.785 501.111 735.257 501.491 733.513 501.491C731.77 501.491 730.241 501.111 729.184 500.544C728.086 499.956 727.724 499.312 727.724 498.854C727.724 498.397 728.086 497.753 729.184 497.164C730.241 496.598 731.77 496.218 733.513 496.218C735.257 496.218 736.785 496.598 737.842 497.164C738.941 497.753 739.303 498.397 739.303 498.854Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M696.625 476.125C696.625 476.583 696.263 477.227 695.164 477.815C694.108 478.381 692.579 478.762 690.835 478.762C689.092 478.762 687.563 478.381 686.507 477.815C685.408 477.227 685.046 476.583 685.046 476.125C685.046 475.668 685.408 475.024 686.507 474.435C687.563 473.869 689.092 473.489 690.835 473.489C692.579 473.489 694.108 473.869 695.164 474.435C696.263 475.024 696.625 475.668 696.625 476.125Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M739.303 477.944C739.303 478.401 738.941 479.045 737.842 479.634C736.785 480.2 735.257 480.581 733.513 480.581C731.77 480.581 730.241 480.2 729.184 479.634C728.086 479.045 727.724 478.401 727.724 477.944C727.724 477.487 728.086 476.842 729.184 476.254C730.241 475.688 731.77 475.307 733.513 475.307C735.257 475.307 736.785 475.688 737.842 476.254C738.941 476.842 739.303 477.487 739.303 477.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M696.625 455.215C696.625 455.672 696.263 456.316 695.164 456.905C694.108 457.471 692.579 457.851 690.835 457.851C689.092 457.851 687.563 457.471 686.507 456.905C685.408 456.316 685.046 455.672 685.046 455.215C685.046 454.757 685.408 454.113 686.507 453.525C687.563 452.959 689.092 452.578 690.835 452.578C692.579 452.578 694.108 452.959 695.164 453.525C696.263 454.113 696.625 454.757 696.625 455.215Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-101-inside-9_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.915 493.733L646.4 470.972L603.826 491.94L646.4 514.731L646.566 514.649L689.08 537.292L731.758 514.563L689.08 493.652L688.915 493.733Z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.915 493.733L646.4 470.972L603.826 491.94L646.4 514.731L646.566 514.649L689.08 537.292L731.758 514.563L689.08 493.652L688.915 493.733Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M646.4 470.972L647.344 469.209L646.438 468.724L645.516 469.178L646.4 470.972ZM688.915 493.733L687.971 495.496L688.875 495.979L689.795 495.529L688.915 493.733ZM603.826 491.94L602.943 490.146L599.45 491.866L602.882 493.703L603.826 491.94ZM646.4 514.731L645.456 516.495L646.362 516.98L647.283 516.526L646.4 514.731ZM646.566 514.649L647.506 512.884L646.602 512.402L645.682 512.855L646.566 514.649ZM689.08 537.292L688.14 539.057L689.08 539.558L690.021 539.057L689.08 537.292ZM731.758 514.563L732.698 516.328L736.152 514.488L732.638 512.767L731.758 514.563ZM689.08 493.652L689.96 491.856L689.08 491.424L688.2 491.856L689.08 493.652ZM645.456 472.735L687.971 495.496L689.859 491.969L647.344 469.209L645.456 472.735ZM604.71 493.734L647.283 472.766L645.516 469.178L602.943 490.146L604.71 493.734ZM647.344 512.968L604.77 490.177L602.882 493.703L645.456 516.495L647.344 512.968ZM645.682 512.855L645.516 512.937L647.283 516.526L647.45 516.444L645.682 512.855ZM690.021 535.527L647.506 512.884L645.626 516.415L688.14 539.057L690.021 535.527ZM730.818 512.797L688.14 535.527L690.021 539.057L732.698 516.328L730.818 512.797ZM688.201 495.448L730.878 516.359L732.638 512.767L689.96 491.856L688.201 495.448ZM689.795 495.529L689.961 495.448L688.2 491.856L688.035 491.937L689.795 495.529Z",
    fill: "black",
    mask: "url(#path-101-inside-9_3131_11627)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M604.726 493.499L645.403 515.163V539.263L604.726 517.599V493.499ZM688.081 561.993L647.403 540.328V516.228L688.081 537.893V561.993Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M730.758 540.329V516.229L690.08 537.893V561.993L730.758 540.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M710.42 508.29C712.416 508.29 714.175 508.766 715.401 509.484C716.65 510.216 717.179 511.082 717.179 511.836V517.291C717.179 518.045 716.65 518.91 715.401 519.642C714.175 520.36 712.416 520.836 710.42 520.836C708.423 520.836 706.664 520.36 705.438 519.642C704.189 518.91 703.66 518.045 703.66 517.291V511.836C703.66 511.082 704.189 510.216 705.438 509.484C706.664 508.766 708.423 508.29 710.42 508.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M667.742 485.561C669.739 485.561 671.498 486.037 672.723 486.755C673.973 487.487 674.502 488.353 674.502 489.107V494.562C674.502 495.316 673.973 496.181 672.723 496.913C671.498 497.631 669.739 498.108 667.742 498.108C665.745 498.108 663.986 497.631 662.761 496.913C661.511 496.181 660.982 495.316 660.982 494.562V489.107C660.982 488.353 661.511 487.487 662.761 486.755C663.986 486.037 665.745 485.561 667.742 485.561Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M716.209 511.836C716.209 512.293 715.847 512.937 714.748 513.526C713.692 514.092 712.163 514.472 710.419 514.472C708.676 514.472 707.147 514.092 706.091 513.526C704.992 512.937 704.63 512.293 704.63 511.836C704.63 511.378 704.992 510.734 706.091 510.146C707.147 509.579 708.676 509.199 710.419 509.199C712.163 509.199 713.692 509.579 714.748 510.146C715.847 510.734 716.209 511.378 716.209 511.836Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M673.531 489.106C673.531 489.564 673.169 490.208 672.071 490.796C671.014 491.362 669.485 491.743 667.742 491.743C665.998 491.743 664.47 491.362 663.413 490.796C662.314 490.208 661.952 489.564 661.952 489.106C661.952 488.649 662.314 488.005 663.413 487.416C664.47 486.85 665.998 486.469 667.742 486.469C669.485 486.469 671.014 486.85 672.071 487.416C673.169 488.005 673.531 488.649 673.531 489.106Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M694.87 501.835C694.87 502.292 694.508 502.936 693.409 503.525C692.353 504.091 690.824 504.471 689.081 504.471C687.337 504.471 685.809 504.091 684.752 503.525C683.653 502.936 683.291 502.292 683.291 501.835C683.291 501.377 683.653 500.733 684.752 500.145C685.809 499.579 687.337 499.198 689.081 499.198C690.824 499.198 692.353 499.579 693.409 500.145C694.508 500.733 694.87 501.377 694.87 501.835Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M652.192 479.106C652.192 479.563 651.83 480.207 650.732 480.796C649.675 481.362 648.146 481.742 646.403 481.742C644.66 481.742 643.131 481.362 642.074 480.796C640.975 480.207 640.613 479.563 640.613 479.106C640.613 478.648 640.975 478.004 642.074 477.416C643.131 476.85 644.66 476.469 646.403 476.469C648.146 476.469 649.675 476.85 650.732 477.416C651.83 478.004 652.192 478.648 652.192 479.106Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M713.458 452.66L753.882 432.751L794.305 452.66L753.882 474.3L713.458 452.66Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M712.204 478.281V454.18L752.882 475.845V499.945L712.204 478.281Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M795.559 478.281V454.18L754.881 475.845V499.945L795.559 478.281Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M732.543 446.242C734.539 446.242 736.298 446.718 737.524 447.436C738.774 448.168 739.302 449.034 739.302 449.788V455.243C739.302 455.997 738.774 456.862 737.524 457.594C736.298 458.312 734.539 458.789 732.543 458.789C730.546 458.789 728.787 458.312 727.561 457.594C726.312 456.862 725.783 455.997 725.783 455.243V449.788C725.783 449.034 726.312 448.168 727.561 447.436C728.787 446.718 730.546 446.242 732.543 446.242Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M738.332 449.788C738.332 450.245 737.97 450.889 736.871 451.478C735.815 452.044 734.286 452.424 732.543 452.424C730.799 452.424 729.27 452.044 728.214 451.478C727.115 450.889 726.753 450.245 726.753 449.788C726.753 449.33 727.115 448.686 728.214 448.098C729.27 447.532 730.799 447.151 732.543 447.151C734.286 447.151 735.815 447.532 736.871 448.098C737.97 448.686 738.332 449.33 738.332 449.788Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M669.712 475.251L710.234 455.396L750.757 475.251L710.234 496.833L669.712 475.251Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M627.132 452.629L667.535 432.73L707.979 454.381L667.576 474.28L627.132 452.629Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-118-inside-10_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 475.216L624.88 452.487V478.853L667.557 501.582V475.216ZM710.235 497.945L667.558 475.216V501.582L710.235 524.311V497.945Z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 475.216L624.88 452.487V478.853L667.557 501.582V475.216ZM710.235 497.945L667.558 475.216V501.582L710.235 524.311V497.945Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M624.88 452.487L625.82 450.722L622.88 449.156V452.487H624.88ZM667.557 475.216H669.557V474.016L668.498 473.451L667.557 475.216ZM624.88 478.853H622.88V480.054L623.94 480.618L624.88 478.853ZM667.557 501.582L666.617 503.348L669.557 504.914V501.582H667.557ZM667.558 475.216L668.498 473.451L665.558 471.885V475.216H667.558ZM710.235 497.945H712.235V496.744L711.175 496.18L710.235 497.945ZM667.558 501.582H665.558V502.783L666.617 503.347L667.558 501.582ZM710.235 524.311L709.295 526.076L712.235 527.642V524.311H710.235ZM623.94 454.252L666.617 476.982L668.498 473.451L625.82 450.722L623.94 454.252ZM626.88 478.853V452.487H622.88V478.853H626.88ZM668.498 499.817L625.82 477.088L623.94 480.618L666.617 503.348L668.498 499.817ZM665.557 475.216V501.582H669.557V475.216H665.557ZM666.617 476.981L709.295 499.71L711.175 496.18L668.498 473.451L666.617 476.981ZM669.558 501.582V475.216H665.558V501.582H669.558ZM711.175 522.546L668.498 499.817L666.617 503.347L709.295 526.076L711.175 522.546ZM708.235 497.945V524.311H712.235V497.945H708.235Z",
    fill: "black",
    mask: "url(#path-118-inside-10_3131_11627)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M751.912 500.981V476.881L711.235 498.546V522.646L751.912 500.981Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-121-inside-11_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.07 426.201L667.555 403.441L624.981 424.409L667.555 447.2L667.722 447.118L710.236 469.76L752.913 447.031L710.236 426.12L710.07 426.201Z"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.07 426.201L667.555 403.441L624.981 424.409L667.555 447.2L667.722 447.118L710.236 469.76L752.913 447.031L710.236 426.12L710.07 426.201Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M667.555 403.441L668.499 401.678L667.593 401.193L666.671 401.647L667.555 403.441ZM710.07 426.201L709.126 427.964L710.03 428.448L710.95 427.997L710.07 426.201ZM624.981 424.409L624.098 422.615L620.605 424.335L624.038 426.172L624.981 424.409ZM667.555 447.2L666.611 448.963L667.517 449.448L668.439 448.994L667.555 447.2ZM667.722 447.118L668.662 445.353L667.757 444.871L666.838 445.324L667.722 447.118ZM710.236 469.76L709.296 471.525L710.236 472.026L711.176 471.525L710.236 469.76ZM752.913 447.031L753.853 448.796L757.307 446.957L753.793 445.235L752.913 447.031ZM710.236 426.12L711.116 424.324L710.236 423.893L709.356 424.324L710.236 426.12ZM666.611 405.204L709.126 427.964L711.014 424.438L668.499 401.678L666.611 405.204ZM625.865 426.203L668.439 405.235L666.671 401.647L624.098 422.615L625.865 426.203ZM668.499 445.437L625.925 422.646L624.038 426.172L666.611 448.963L668.499 445.437ZM666.838 445.324L666.671 445.406L668.439 448.994L668.605 448.912L666.838 445.324ZM711.176 467.995L668.662 445.353L666.782 448.883L709.296 471.525L711.176 467.995ZM751.973 445.266L709.296 467.995L711.176 471.525L753.853 448.796L751.973 445.266ZM709.356 427.916L752.033 448.827L753.793 445.235L711.116 424.324L709.356 427.916ZM710.95 427.997L711.116 427.916L709.356 424.324L709.19 424.405L710.95 427.997Z",
    fill: "black",
    mask: "url(#path-121-inside-11_3131_11627)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-123-inside-12_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 447.032L624.88 424.302V450.668L667.557 473.398V447.032ZM710.235 469.76L667.558 447.031V473.397L710.235 496.127V469.76Z"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.557 447.032L624.88 424.302V450.668L667.557 473.398V447.032ZM710.235 469.76L667.558 447.031V473.397L710.235 496.127V469.76Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M624.88 424.302L625.82 422.537L622.88 420.971V424.302H624.88ZM667.557 447.032H669.557V445.831L668.498 445.266L667.557 447.032ZM624.88 450.668H622.88V451.869L623.94 452.434L624.88 450.668ZM667.557 473.398L666.617 475.163L669.557 476.729V473.398H667.557ZM667.558 447.031L668.498 445.266L665.558 443.7V447.031H667.558ZM710.235 469.76H712.235V468.56L711.175 467.995L710.235 469.76ZM667.558 473.397H665.558V474.598L666.617 475.162L667.558 473.397ZM710.235 496.127L709.295 497.892L712.235 499.458V496.127H710.235ZM623.94 426.068L666.617 448.797L668.498 445.266L625.82 422.537L623.94 426.068ZM626.88 450.668V424.302H622.88V450.668H626.88ZM668.498 471.633L625.82 448.903L623.94 452.434L666.617 475.163L668.498 471.633ZM665.557 447.032V473.398H669.557V447.032H665.557ZM666.617 448.796L709.295 471.526L711.175 467.995L668.498 445.266L666.617 448.796ZM669.558 473.397V447.031H665.558V473.397H669.558ZM711.175 494.361L668.498 471.632L666.617 475.162L709.295 497.892L711.175 494.361ZM708.235 469.76V496.127H712.235V469.76H708.235Z",
    fill: "black",
    mask: "url(#path-123-inside-12_3131_11627)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M751.912 472.797V448.697L711.235 470.361V494.461L751.912 472.797Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-126-inside-13_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.916 729.074L793.401 706.313L750.827 727.281L793.401 750.073L793.567 749.991L836.081 772.633L878.759 749.904L836.081 728.993L835.916 729.074Z"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.916 729.074L793.401 706.313L750.827 727.281L793.401 750.073L793.567 749.991L836.081 772.633L878.759 749.904L836.081 728.993L835.916 729.074Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M793.401 706.313L794.345 704.55L793.439 704.065L792.517 704.519L793.401 706.313ZM835.916 729.074L834.972 730.837L835.876 731.321L836.796 730.87L835.916 729.074ZM750.827 727.281L749.943 725.487L746.451 727.207L749.883 729.045L750.827 727.281ZM793.401 750.073L792.457 751.836L793.363 752.321L794.284 751.867L793.401 750.073ZM793.567 749.991L794.507 748.226L793.603 747.744L792.683 748.197L793.567 749.991ZM836.081 772.633L835.141 774.399L836.081 774.899L837.022 774.399L836.081 772.633ZM878.759 749.904L879.699 751.669L883.153 749.83L879.639 748.108L878.759 749.904ZM836.081 728.993L836.961 727.197L836.081 726.766L835.201 727.197L836.081 728.993ZM792.457 708.077L834.972 730.837L836.86 727.311L794.345 704.55L792.457 708.077ZM751.711 729.076L794.284 708.108L792.517 704.519L749.943 725.487L751.711 729.076ZM794.345 748.309L751.771 725.518L749.883 729.045L792.457 751.836L794.345 748.309ZM792.683 748.197L792.517 748.279L794.284 751.867L794.451 751.785L792.683 748.197ZM837.022 770.868L794.507 748.226L792.627 751.756L835.141 774.399L837.022 770.868ZM877.819 748.139L835.141 770.868L837.022 774.399L879.699 751.669L877.819 748.139ZM835.201 730.789L877.879 751.7L879.639 748.108L836.961 727.197L835.201 730.789ZM836.796 730.87L836.961 730.789L835.201 727.197L835.036 727.278L836.796 730.87Z",
    fill: "black",
    mask: "url(#path-126-inside-13_3131_11627)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-128-inside-14_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.403 749.905L750.726 727.175V753.541L793.403 776.271V749.905ZM836.081 772.634L793.403 749.905V776.271L836.081 799V772.634Z"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.403 749.905L750.726 727.175V753.541L793.403 776.271V749.905ZM836.081 772.634L793.403 749.905V776.271L836.081 799V772.634Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M750.726 727.175L751.666 725.41L748.726 723.844V727.175H750.726ZM793.403 749.905H795.403V748.704L794.343 748.139L793.403 749.905ZM750.726 753.541H748.726V754.742L749.785 755.307L750.726 753.541ZM793.403 776.271L792.463 778.036L795.403 779.602V776.271H793.403ZM793.403 749.905L794.343 748.14L791.403 746.574V749.905H793.403ZM836.081 772.634H838.081V771.433L837.021 770.869L836.081 772.634ZM793.403 776.271H791.403V777.472L792.463 778.036L793.403 776.271ZM836.081 799L835.141 800.765L838.081 802.331V799H836.081ZM749.785 728.941L792.463 751.67L794.343 748.139L751.666 725.41L749.785 728.941ZM752.726 753.541V727.175H748.726V753.541H752.726ZM794.343 774.505L751.666 751.776L749.785 755.307L792.463 778.036L794.343 774.505ZM791.403 749.905V776.271H795.403V749.905H791.403ZM792.463 751.67L835.141 774.399L837.021 770.869L794.343 748.14L792.463 751.67ZM795.403 776.271V749.905H791.403V776.271H795.403ZM837.021 797.235L794.343 774.506L792.463 778.036L835.141 800.765L837.021 797.235ZM834.081 772.634V799H838.081V772.634H834.081Z",
    fill: "black",
    mask: "url(#path-128-inside-14_3131_11627)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M877.758 775.67V751.57L837.08 773.234V797.334L877.758 775.67Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 323.547L949.532 303.637L989.956 323.547L949.532 345.187L909.109 323.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 349.168V325.068L948.532 346.732V370.832L907.854 349.168Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 349.168V325.068L950.531 346.732V370.832L991.209 349.168Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M970.871 317.129C972.868 317.129 974.627 317.605 975.852 318.323C977.102 319.055 977.63 319.921 977.63 320.675V326.13C977.63 326.884 977.102 327.749 975.852 328.481C974.627 329.199 972.868 329.676 970.871 329.676C968.874 329.676 967.115 329.199 965.89 328.481C964.64 327.749 964.111 326.884 964.111 326.13V320.675C964.111 319.921 964.64 319.055 965.89 318.323C967.115 317.605 968.874 317.129 970.871 317.129Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M928.193 317.129C930.19 317.129 931.949 317.605 933.174 318.323C934.424 319.055 934.953 319.921 934.953 320.675V326.13C934.953 326.884 934.424 327.749 933.174 328.481C931.949 329.199 930.19 329.676 928.193 329.676C926.196 329.676 924.437 329.199 923.212 328.481C921.962 327.749 921.434 326.884 921.434 326.13V320.675C921.434 319.921 921.962 319.055 923.212 318.323C924.437 317.605 926.196 317.129 928.193 317.129Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 328.039C951.529 328.039 953.288 328.515 954.513 329.233C955.763 329.965 956.292 330.831 956.292 331.585V337.04C956.292 337.794 955.763 338.659 954.513 339.391C953.288 340.109 951.529 340.586 949.532 340.586C947.535 340.586 945.776 340.109 944.551 339.391C943.301 338.659 942.772 337.794 942.772 337.04V331.585C942.772 330.831 943.301 329.965 944.551 329.233C945.776 328.515 947.535 328.039 949.532 328.039Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 307.128C951.529 307.128 953.288 307.605 954.513 308.323C955.763 309.055 956.292 309.92 956.292 310.674V316.129C956.292 316.883 955.763 317.749 954.513 318.481C953.288 319.199 951.529 319.675 949.532 319.675C947.535 319.675 945.776 319.199 944.551 318.481C943.301 317.749 942.772 316.883 942.772 316.129V310.674C942.772 309.92 943.301 309.055 944.551 308.323C945.776 307.605 947.535 307.128 949.532 307.128Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M976.66 320.675C976.66 321.132 976.298 321.776 975.199 322.365C974.143 322.931 972.614 323.311 970.871 323.311C969.127 323.311 967.599 322.931 966.542 322.365C965.443 321.776 965.081 321.132 965.081 320.675C965.081 320.217 965.443 319.573 966.542 318.985C967.599 318.419 969.127 318.038 970.871 318.038C972.614 318.038 974.143 318.419 975.199 318.985C976.298 319.573 976.66 320.217 976.66 320.675Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M933.983 320.675C933.983 321.132 933.62 321.776 932.522 322.365C931.465 322.931 929.936 323.311 928.193 323.311C926.45 323.311 924.921 322.931 923.864 322.365C922.765 321.776 922.403 321.132 922.403 320.675C922.403 320.217 922.765 319.573 923.864 318.985C924.921 318.419 926.45 318.038 928.193 318.038C929.936 318.038 931.465 318.419 932.522 318.985C933.62 319.573 933.983 320.217 933.983 320.675Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 331.585C955.321 332.042 954.959 332.686 953.861 333.275C952.804 333.841 951.275 334.222 949.532 334.222C947.788 334.222 946.26 333.841 945.203 333.275C944.104 332.686 943.742 332.042 943.742 331.585C943.742 331.127 944.104 330.483 945.203 329.895C946.26 329.329 947.788 328.948 949.532 328.948C951.275 328.948 952.804 329.329 953.861 329.895C954.959 330.483 955.321 331.127 955.321 331.585Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 310.674C955.321 311.131 954.959 311.775 953.861 312.364C952.804 312.93 951.275 313.31 949.532 313.31C947.788 313.31 946.26 312.93 945.203 312.364C944.104 311.775 943.742 311.131 943.742 310.674C943.742 310.216 944.104 309.572 945.203 308.984C946.26 308.418 947.788 308.037 949.532 308.037C951.275 308.037 952.804 308.418 953.861 308.984C954.959 309.572 955.321 310.216 955.321 310.674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 295.362L949.532 275.453L989.956 295.362L949.532 317.003L909.109 295.362Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 320.983V296.883L948.532 318.548V342.648L907.854 320.983Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 320.983V296.883L950.531 318.548V342.648L991.209 320.983Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M970.871 288.945C972.868 288.945 974.627 289.421 975.852 290.139C977.102 290.871 977.63 291.737 977.63 292.491V297.946C977.63 298.7 977.102 299.565 975.852 300.297C974.627 301.015 972.868 301.491 970.871 301.491C968.874 301.491 967.115 301.015 965.89 300.297C964.64 299.565 964.111 298.7 964.111 297.946V292.491C964.111 291.737 964.64 290.871 965.89 290.139C967.115 289.421 968.874 288.945 970.871 288.945Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M928.193 288.945C930.19 288.945 931.949 289.421 933.174 290.139C934.424 290.871 934.953 291.737 934.953 292.491V297.946C934.953 298.7 934.424 299.565 933.174 300.297C931.949 301.015 930.19 301.491 928.193 301.491C926.196 301.491 924.437 301.015 923.212 300.297C921.962 299.565 921.434 298.7 921.434 297.946V292.491C921.434 291.737 921.962 290.871 923.212 290.139C924.437 289.421 926.196 288.945 928.193 288.945Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 299.855C951.529 299.855 953.288 300.331 954.513 301.049C955.763 301.781 956.292 302.647 956.292 303.401V308.856C956.292 309.61 955.763 310.475 954.513 311.207C953.288 311.925 951.529 312.402 949.532 312.402C947.535 312.402 945.776 311.925 944.551 311.207C943.301 310.475 942.772 309.61 942.772 308.856V303.401C942.772 302.647 943.301 301.781 944.551 301.049C945.776 300.331 947.535 299.855 949.532 299.855Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 278.944C951.529 278.944 953.288 279.421 954.513 280.139C955.763 280.871 956.292 281.736 956.292 282.49V287.945C956.292 288.699 955.763 289.565 954.513 290.297C953.288 291.015 951.529 291.491 949.532 291.491C947.535 291.491 945.776 291.015 944.551 290.297C943.301 289.565 942.772 288.699 942.772 287.945V282.49C942.772 281.736 943.301 280.871 944.551 280.139C945.776 279.421 947.535 278.944 949.532 278.944Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M976.66 292.491C976.66 292.948 976.298 293.592 975.199 294.181C974.143 294.747 972.614 295.127 970.871 295.127C969.127 295.127 967.599 294.747 966.542 294.181C965.443 293.592 965.081 292.948 965.081 292.491C965.081 292.033 965.443 291.389 966.542 290.801C967.599 290.235 969.127 289.854 970.871 289.854C972.614 289.854 974.143 290.235 975.199 290.801C976.298 291.389 976.66 292.033 976.66 292.491Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M933.983 292.491C933.983 292.948 933.62 293.592 932.522 294.181C931.465 294.747 929.936 295.127 928.193 295.127C926.45 295.127 924.921 294.747 923.864 294.181C922.765 293.592 922.403 292.948 922.403 292.491C922.403 292.033 922.765 291.389 923.864 290.801C924.921 290.235 926.45 289.854 928.193 289.854C929.936 289.854 931.465 290.235 932.522 290.801C933.62 291.389 933.983 292.033 933.983 292.491Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 303.401C955.321 303.858 954.959 304.502 953.861 305.091C952.804 305.657 951.275 306.037 949.532 306.037C947.788 306.037 946.26 305.657 945.203 305.091C944.104 304.502 943.742 303.858 943.742 303.401C943.742 302.943 944.104 302.299 945.203 301.711C946.26 301.145 947.788 300.764 949.532 300.764C951.275 300.764 952.804 301.145 953.861 301.711C954.959 302.299 955.321 302.943 955.321 303.401Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 282.49C955.321 282.947 954.959 283.591 953.861 284.18C952.804 284.746 951.275 285.126 949.532 285.126C947.788 285.126 946.26 284.746 945.203 284.18C944.104 283.591 943.742 282.947 943.742 282.49C943.742 282.032 944.104 281.388 945.203 280.8C946.26 280.234 947.788 279.853 949.532 279.853C951.275 279.853 952.804 280.234 953.861 280.8C954.959 281.388 955.321 282.032 955.321 282.49Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 267.178L949.532 247.269L989.956 267.178L949.532 288.818L909.109 267.178Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 292.799V268.699L948.532 290.363V314.463L907.854 292.799Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 292.799V268.699L950.531 290.363V314.463L991.209 292.799Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M970.871 260.76C972.868 260.76 974.627 261.236 975.852 261.954C977.102 262.687 977.63 263.552 977.63 264.306V269.761C977.63 270.515 977.102 271.381 975.852 272.113C974.627 272.831 972.868 273.307 970.871 273.307C968.874 273.307 967.115 272.831 965.89 272.113C964.64 271.381 964.111 270.515 964.111 269.761V264.306C964.111 263.552 964.64 262.687 965.89 261.954C967.115 261.236 968.874 260.76 970.871 260.76Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M928.193 260.76C930.19 260.76 931.949 261.236 933.174 261.954C934.424 262.687 934.953 263.552 934.953 264.306V269.761C934.953 270.515 934.424 271.381 933.174 272.113C931.949 272.831 930.19 273.307 928.193 273.307C926.196 273.307 924.437 272.831 923.212 272.113C921.962 271.381 921.434 270.515 921.434 269.761V264.306C921.434 263.552 921.962 262.687 923.212 261.954C924.437 261.236 926.196 260.76 928.193 260.76Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 271.67C951.529 271.67 953.288 272.146 954.513 272.865C955.763 273.597 956.292 274.462 956.292 275.216V280.671C956.292 281.425 955.763 282.291 954.513 283.023C953.288 283.741 951.529 284.217 949.532 284.217C947.535 284.217 945.776 283.741 944.551 283.023C943.301 282.291 942.772 281.425 942.772 280.671V275.216C942.772 274.462 943.301 273.597 944.551 272.865C945.776 272.146 947.535 271.67 949.532 271.67Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 250.76C951.529 250.76 953.288 251.236 954.513 251.954C955.763 252.687 956.292 253.552 956.292 254.306V259.761C956.292 260.515 955.763 261.381 954.513 262.113C953.288 262.831 951.529 263.307 949.532 263.307C947.535 263.307 945.776 262.831 944.551 262.113C943.301 261.381 942.772 260.515 942.772 259.761V254.306C942.772 253.552 943.301 252.687 944.551 251.954C945.776 251.236 947.535 250.76 949.532 250.76Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M976.66 264.306C976.66 264.763 976.298 265.407 975.199 265.996C974.143 266.562 972.614 266.943 970.871 266.943C969.127 266.943 967.599 266.562 966.542 265.996C965.443 265.407 965.081 264.763 965.081 264.306C965.081 263.849 965.443 263.204 966.542 262.616C967.599 262.05 969.127 261.669 970.871 261.669C972.614 261.669 974.143 262.05 975.199 262.616C976.298 263.204 976.66 263.849 976.66 264.306Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M933.983 264.306C933.983 264.763 933.62 265.407 932.522 265.996C931.465 266.562 929.936 266.943 928.193 266.943C926.45 266.943 924.921 266.562 923.864 265.996C922.765 265.407 922.403 264.763 922.403 264.306C922.403 263.849 922.765 263.204 923.864 262.616C924.921 262.05 926.45 261.669 928.193 261.669C929.936 261.669 931.465 262.05 932.522 262.616C933.62 263.204 933.983 263.849 933.983 264.306Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 275.217C955.321 275.674 954.959 276.318 953.861 276.907C952.804 277.473 951.275 277.853 949.532 277.853C947.788 277.853 946.26 277.473 945.203 276.907C944.104 276.318 943.742 275.674 943.742 275.217C943.742 274.759 944.104 274.115 945.203 273.527C946.26 272.96 947.788 272.58 949.532 272.58C951.275 272.58 952.804 272.96 953.861 273.527C954.959 274.115 955.321 274.759 955.321 275.217Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 254.305C955.321 254.762 954.959 255.406 953.861 255.995C952.804 256.561 951.275 256.942 949.532 256.942C947.788 256.942 946.26 256.561 945.203 255.995C944.104 255.406 943.742 254.762 943.742 254.305C943.742 253.848 944.104 253.203 945.203 252.615C946.26 252.049 947.788 251.668 949.532 251.668C951.275 251.668 952.804 252.049 953.861 252.615C954.959 253.203 955.321 253.848 955.321 254.305Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 238.993L949.532 219.084L989.956 238.993L949.532 260.634L909.109 238.993Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 264.614V240.514L948.532 262.178V286.278L907.854 264.614Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 264.614V240.514L950.531 262.178V286.278L991.209 264.614Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M970.871 232.576C972.868 232.576 974.627 233.052 975.852 233.77C977.102 234.502 977.63 235.368 977.63 236.122V241.577C977.63 242.331 977.102 243.196 975.852 243.928C974.627 244.646 972.868 245.123 970.871 245.123C968.874 245.123 967.115 244.646 965.89 243.928C964.64 243.196 964.111 242.331 964.111 241.577V236.122C964.111 235.368 964.64 234.502 965.89 233.77C967.115 233.052 968.874 232.576 970.871 232.576Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M928.193 232.576C930.19 232.576 931.949 233.052 933.174 233.77C934.424 234.502 934.953 235.368 934.953 236.122V241.577C934.953 242.331 934.424 243.196 933.174 243.928C931.949 244.646 930.19 245.123 928.193 245.123C926.196 245.123 924.437 244.646 923.212 243.928C921.962 243.196 921.434 242.331 921.434 241.577V236.122C921.434 235.368 921.962 234.502 923.212 233.77C924.437 233.052 926.196 232.576 928.193 232.576Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 243.486C951.529 243.486 953.288 243.962 954.513 244.68C955.763 245.412 956.292 246.277 956.292 247.031V252.487C956.292 253.241 955.763 254.106 954.513 254.838C953.288 255.556 951.529 256.032 949.532 256.032C947.535 256.032 945.776 255.556 944.551 254.838C943.301 254.106 942.772 253.241 942.772 252.487V247.031C942.772 246.277 943.301 245.412 944.551 244.68C945.776 243.962 947.535 243.486 949.532 243.486Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M949.532 222.575C951.529 222.575 953.288 223.052 954.513 223.77C955.763 224.502 956.292 225.367 956.292 226.121V231.576C956.292 232.33 955.763 233.196 954.513 233.928C953.288 234.646 951.529 235.122 949.532 235.122C947.535 235.122 945.776 234.646 944.551 233.928C943.301 233.196 942.772 232.33 942.772 231.576V226.121C942.772 225.367 943.301 224.502 944.551 223.77C945.776 223.052 947.535 222.575 949.532 222.575Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M976.66 236.121C976.66 236.579 976.298 237.223 975.199 237.811C974.143 238.377 972.614 238.758 970.871 238.758C969.127 238.758 967.599 238.377 966.542 237.811C965.443 237.223 965.081 236.579 965.081 236.121C965.081 235.664 965.443 235.02 966.542 234.431C967.599 233.865 969.127 233.485 970.871 233.485C972.614 233.485 974.143 233.865 975.199 234.431C976.298 235.02 976.66 235.664 976.66 236.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M933.983 236.121C933.983 236.579 933.62 237.223 932.522 237.811C931.465 238.377 929.936 238.758 928.193 238.758C926.45 238.758 924.921 238.377 923.864 237.811C922.765 237.223 922.403 236.579 922.403 236.121C922.403 235.664 922.765 235.02 923.864 234.431C924.921 233.865 926.45 233.485 928.193 233.485C929.936 233.485 931.465 233.865 932.522 234.431C933.62 235.02 933.983 235.664 933.983 236.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 247.032C955.321 247.489 954.959 248.133 953.861 248.722C952.804 249.288 951.275 249.669 949.532 249.669C947.788 249.669 946.26 249.288 945.203 248.722C944.104 248.133 943.742 247.489 943.742 247.032C943.742 246.574 944.104 245.93 945.203 245.342C946.26 244.776 947.788 244.395 949.532 244.395C951.275 244.395 952.804 244.776 953.861 245.342C954.959 245.93 955.321 246.574 955.321 247.032Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M955.321 226.121C955.321 226.578 954.959 227.222 953.861 227.811C952.804 228.377 951.275 228.758 949.532 228.758C947.788 228.758 946.26 228.377 945.203 227.811C944.104 227.222 943.742 226.578 943.742 226.121C943.742 225.663 944.104 225.019 945.203 224.431C946.26 223.865 947.788 223.484 949.532 223.484C951.275 223.484 952.804 223.865 953.861 224.431C954.959 225.019 955.321 225.663 955.321 226.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M997.727 33.468L1039.4 13.1129L1081.08 33.468V58.2272L1039.4 80.2385L997.727 58.2272V33.468Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M997.941 58.5581V34.6742L1038.62 56.1573V80.0412L997.941 58.5581Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.3 58.5581V34.6742L1040.62 56.1573V80.0412L1081.3 58.5581Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M411.671 259.996L444.321 243.998L476.972 259.996L444.321 277.385L411.671 259.996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M410.515 280.863V261.626L443.321 279.098V298.335L410.515 280.863Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M478.128 280.863V261.626L445.322 279.098V298.335L478.128 280.863Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-181-inside-15_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.199 218.902L479.403 200.056L514.655 217.418L479.403 236.29L479.267 236.223L444.065 254.971L408.726 236.151L444.065 218.836L444.199 218.902Z"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.199 218.902L479.403 200.056L514.655 217.418L479.403 236.29L479.267 236.223L444.065 254.971L408.726 236.151L444.065 218.836L444.199 218.902Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M479.403 200.056L478.459 198.292L479.365 197.807L480.287 198.261L479.403 200.056ZM444.199 218.902L445.143 220.665L444.24 221.149L443.319 220.698L444.199 218.902ZM514.655 217.418L515.539 215.624L519.031 217.344L515.599 219.181L514.655 217.418ZM479.403 236.29L480.347 238.053L479.441 238.538L478.519 238.084L479.403 236.29ZM479.267 236.223L478.327 234.458L479.232 233.976L480.151 234.429L479.267 236.223ZM444.065 254.971L445.005 256.737L444.065 257.237L443.124 256.737L444.065 254.971ZM408.726 236.151L407.786 237.916L404.332 236.076L407.846 234.355L408.726 236.151ZM444.065 218.836L443.185 217.04L444.065 216.608L444.945 217.04L444.065 218.836ZM480.347 201.819L445.143 220.665L443.255 217.138L478.459 198.292L480.347 201.819ZM513.772 219.212L478.519 201.85L480.287 198.261L515.539 215.624L513.772 219.212ZM478.459 234.527L513.711 215.655L515.599 219.181L480.347 238.053L478.459 234.527ZM480.151 234.429L480.287 234.496L478.519 238.084L478.384 238.017L480.151 234.429ZM443.124 253.206L478.327 234.458L480.207 237.988L445.005 256.737L443.124 253.206ZM409.666 234.385L445.005 253.206L443.124 256.737L407.786 237.916L409.666 234.385ZM444.945 220.632L409.606 237.947L407.846 234.355L443.185 217.04L444.945 220.632ZM443.319 220.698L443.185 220.632L444.945 217.04L445.079 217.106L443.319 220.698Z",
    fill: "black",
    mask: "url(#path-181-inside-15_3131_11627)"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-183-inside-16_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.402 236.15L514.74 217.33V239.162L479.402 257.982V257.982L444.064 276.802V254.971L479.402 236.15V236.15Z"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.402 236.15L514.74 217.33V239.162L479.402 257.982V257.982L444.064 276.802V254.971L479.402 236.15V236.15Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M514.74 217.33L513.8 215.565L516.74 213.999V217.33H514.74ZM479.402 236.15L480.342 237.916L477.402 239.481V236.15H479.402ZM514.74 239.162H516.74V240.363L515.68 240.927L514.74 239.162ZM479.402 257.982L480.342 259.748L477.402 261.314V257.982H479.402ZM479.402 257.982L478.462 256.217L481.402 254.651V257.982H479.402ZM444.064 276.802L445.004 278.568L442.064 280.134V276.802H444.064ZM444.064 254.971H442.064V253.77L443.124 253.205L444.064 254.971ZM479.402 236.15L478.462 234.385L481.402 232.819V236.15H479.402ZM515.68 219.095L480.342 237.916L478.462 234.385L513.8 215.565L515.68 219.095ZM512.74 239.162V217.33H516.74V239.162H512.74ZM478.462 256.217L513.8 237.397L515.68 240.927L480.342 259.748L478.462 256.217ZM481.402 257.982V257.982H477.402V257.982H481.402ZM443.124 275.037L478.462 256.217L480.342 259.747L445.004 278.568L443.124 275.037ZM446.064 254.971V276.802H442.064V254.971H446.064ZM480.342 237.915L445.004 256.736L443.124 253.205L478.462 234.385L480.342 237.915ZM477.402 236.15V236.15H481.402V236.15H477.402Z",
    fill: "black",
    mask: "url(#path-183-inside-16_3131_11627)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M409.726 257.382V237.816L443.064 255.571V275.137L409.726 257.382Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 210.809L949.532 190.9L989.956 210.809L949.532 232.45L909.109 210.809Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 236.43V212.33L948.532 233.994V258.094L907.854 236.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 236.43V212.33L950.531 233.994V258.094L991.209 236.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M909.109 182.625L949.532 162.716L989.956 182.625L949.532 204.266L909.109 182.625Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M907.854 208.246V184.146L948.532 205.81V229.91L907.854 208.246Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 208.246V184.146L950.531 205.81V229.91L991.209 208.246Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M409.077 667.392L449.501 647.483L489.925 667.392L449.501 689.033L409.077 667.392Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M407.823 693.013V668.913L448.501 690.577V714.677L407.823 693.013Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M491.178 693.013V668.913L450.5 690.577V714.677L491.178 693.013Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M409.077 639.208L449.501 619.299L489.925 639.208L449.501 660.848L409.077 639.208Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M407.823 664.829V640.729L448.501 662.393V686.493L407.823 664.829Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M491.178 664.829V640.729L450.5 662.393V686.493L491.178 664.829Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M451.98 746.01L492.403 726.101L532.827 746.01L492.403 767.65L451.98 746.01Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M450.726 771.631V747.531L491.403 769.195V793.295L450.726 771.631Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M534.08 771.631V747.531L493.403 769.195V793.295L534.08 771.631Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M452.175 718.116L492.658 696.613L533.142 718.116L492.658 739.789L452.175 718.116Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M450.98 743.769V719.669L491.658 741.333V765.433L450.98 743.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M534.336 743.769V719.669L493.658 741.333V765.433L534.336 743.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.73 742.795V718.695L1103.4 740.359V764.459L1062.73 742.795Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-205-inside-17_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.57 696.199L1147.08 673.439L1189.66 694.407L1147.08 717.198L1146.92 717.116L1104.4 739.759L1061.73 717.029L1104.4 696.118L1104.57 696.199Z"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.57 696.199L1147.08 673.439L1189.66 694.407L1147.08 717.198L1146.92 717.116L1104.4 739.759L1061.73 717.029L1104.4 696.118L1104.57 696.199Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.08 673.439L1146.14 671.676L1147.05 671.191L1147.97 671.645L1147.08 673.439ZM1104.57 696.199L1105.51 697.963L1104.61 698.446L1103.69 697.995L1104.57 696.199ZM1189.66 694.407L1190.54 692.613L1194.03 694.333L1190.6 696.17L1189.66 694.407ZM1147.08 717.198L1148.03 718.961L1147.12 719.446L1146.2 718.992L1147.08 717.198ZM1146.92 717.116L1145.98 715.351L1146.88 714.869L1147.8 715.322L1146.92 717.116ZM1104.4 739.759L1105.34 741.524L1104.4 742.025L1103.46 741.524L1104.4 739.759ZM1061.73 717.029L1060.79 718.795L1057.33 716.955L1060.85 715.233L1061.73 717.029ZM1104.4 696.118L1103.52 694.322L1104.4 693.891L1105.28 694.322L1104.4 696.118ZM1148.03 675.202L1105.51 697.963L1103.62 694.436L1146.14 671.676L1148.03 675.202ZM1188.77 696.201L1146.2 675.233L1147.97 671.645L1190.54 692.613L1188.77 696.201ZM1146.14 715.435L1188.71 692.644L1190.6 696.17L1148.03 718.961L1146.14 715.435ZM1147.8 715.322L1147.97 715.404L1146.2 718.992L1146.03 718.91L1147.8 715.322ZM1103.46 737.994L1145.98 715.351L1147.86 718.882L1105.34 741.524L1103.46 737.994ZM1062.67 715.264L1105.34 737.994L1103.46 741.524L1060.79 718.795L1062.67 715.264ZM1105.28 697.914L1062.61 718.825L1060.85 715.233L1103.52 694.322L1105.28 697.914ZM1103.69 697.995L1103.52 697.914L1105.28 694.322L1105.45 694.403L1103.69 697.995Z",
    fill: "black",
    mask: "url(#path-205-inside-17_3131_11627)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-207-inside-18_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.08 717.03L1189.76 694.3V720.666L1147.08 743.396V717.03ZM1104.4 739.759L1147.08 717.03V743.396L1104.4 766.125V739.759Z"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.08 717.03L1189.76 694.3V720.666L1147.08 743.396V717.03ZM1104.4 739.759L1147.08 717.03V743.396L1104.4 766.125V739.759Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.76 694.3L1188.82 692.535L1191.76 690.969V694.3H1189.76ZM1147.08 717.03H1145.08V715.829L1146.14 715.264L1147.08 717.03ZM1189.76 720.666H1191.76V721.867L1190.7 722.432L1189.76 720.666ZM1147.08 743.396L1148.02 745.161L1145.08 746.727V743.396H1147.08ZM1147.08 717.03L1146.14 715.265L1149.08 713.699V717.03H1147.08ZM1104.4 739.759H1102.4V738.558L1103.46 737.994L1104.4 739.759ZM1147.08 743.396H1149.08V744.597L1148.02 745.161L1147.08 743.396ZM1104.4 766.125L1105.34 767.89L1102.4 769.456V766.125H1104.4ZM1190.7 696.066L1148.02 718.795L1146.14 715.264L1188.82 692.535L1190.7 696.066ZM1187.76 720.666V694.3H1191.76V720.666H1187.76ZM1146.14 741.63L1188.82 718.901L1190.7 722.432L1148.02 745.161L1146.14 741.63ZM1149.08 717.03V743.396H1145.08V717.03H1149.08ZM1148.02 718.795L1105.34 741.524L1103.46 737.994L1146.14 715.265L1148.02 718.795ZM1145.08 743.396V717.03H1149.08V743.396H1145.08ZM1103.46 764.36L1146.14 741.631L1148.02 745.161L1105.34 767.89L1103.46 764.36ZM1106.4 739.759V766.125H1102.4V739.759H1106.4Z",
    fill: "black",
    mask: "url(#path-207-inside-18_3131_11627)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M992.964 78.479L952.441 58.6239L911.919 78.479L952.441 100.061L992.964 78.479Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M910.764 104.209V80.1093L951.441 101.773V125.874L910.764 104.209Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.55 55.8566L995.143 35.9576L954.699 57.6089L995.102 77.508L1035.55 55.8566Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M994.119 104.209L953.441 125.874V101.774L994.119 80.1093V104.209ZM996.119 103.144V79.0441L1036.8 57.3799V81.48L996.119 103.144Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M731.98 58.1481L772.403 38.239L812.827 58.1481L772.403 79.7885L731.98 58.1481Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M730.726 83.7691V59.669L771.403 81.3332V105.433L730.726 83.7691Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M814.08 83.7691V59.669L773.403 81.3332V105.433L814.08 83.7691Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M902.945 131.576V107.476L862.268 129.14V153.24L902.945 131.576Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-217-inside-19_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.103 84.9791L818.588 62.2192L776.015 83.1872L818.588 105.978L818.754 105.897L861.267 128.539L903.945 105.81L861.267 84.8987L861.103 84.9791Z"
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.103 84.9791L818.588 62.2192L776.015 83.1872L818.588 105.978L818.754 105.897L861.267 128.539L903.945 105.81L861.267 84.8987L861.103 84.9791Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M818.588 62.2192L819.532 60.456L818.626 59.9711L817.704 60.425L818.588 62.2192ZM861.103 84.9791L860.159 86.7423L861.063 87.2261L861.983 86.7751L861.103 84.9791ZM776.015 83.1872L775.131 81.393L771.639 83.1131L775.071 84.9505L776.015 83.1872ZM818.588 105.978L817.644 107.742L818.55 108.227L819.472 107.773L818.588 105.978ZM818.754 105.897L819.694 104.132L818.789 103.65L817.87 104.103L818.754 105.897ZM861.267 128.539L860.327 130.304L861.267 130.805L862.207 130.304L861.267 128.539ZM903.945 105.81L904.885 107.575L908.339 105.735L904.825 104.014L903.945 105.81ZM861.267 84.8987L862.147 83.1027L861.267 82.6715L860.387 83.1027L861.267 84.8987ZM817.644 63.9825L860.159 86.7423L862.047 83.2159L819.532 60.456L817.644 63.9825ZM776.898 84.9814L819.472 64.0134L817.704 60.425L775.131 81.393L776.898 84.9814ZM819.532 104.215L776.959 81.424L775.071 84.9505L817.644 107.742L819.532 104.215ZM817.87 104.103L817.704 104.184L819.472 107.773L819.637 107.691L817.87 104.103ZM862.207 126.774L819.694 104.132L817.813 107.662L860.327 130.304L862.207 126.774ZM903.004 104.044L860.327 126.774L862.207 130.304L904.885 107.575L903.004 104.044ZM860.387 86.6947L903.065 107.606L904.825 104.014L862.147 83.1027L860.387 86.6947ZM861.983 86.7751L862.147 86.6947L860.387 83.1027L860.223 83.1831L861.983 86.7751Z",
    fill: "black",
    mask: "url(#path-217-inside-19_3131_11627)"
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-219-inside-20_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M818.59 105.81L775.912 83.0807V109.447L818.59 132.176V105.81ZM861.267 128.54L818.59 105.81V132.176L861.267 154.906V128.54Z"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M818.59 105.81L775.912 83.0807V109.447L818.59 132.176V105.81ZM861.267 128.54L818.59 105.81V132.176L861.267 154.906V128.54Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M775.912 83.0807L776.852 81.3154L773.912 79.7496V83.0807H775.912ZM818.59 105.81H820.59V104.609L819.53 104.045L818.59 105.81ZM775.912 109.447H773.912V110.648L774.972 111.212L775.912 109.447ZM818.59 132.176L817.649 133.941L820.59 135.507V132.176H818.59ZM818.59 105.81L819.53 104.045L816.59 102.479V105.81H818.59ZM861.267 128.54H863.267V127.339L862.207 126.775L861.267 128.54ZM818.59 132.176H816.59V133.377L817.65 133.942L818.59 132.176ZM861.267 154.906L860.327 156.671L863.267 158.237V154.906H861.267ZM774.972 84.8459L817.649 107.575L819.53 104.045L776.852 81.3154L774.972 84.8459ZM777.912 109.447V83.0807H773.912V109.447H777.912ZM819.53 130.411L776.852 107.681L774.972 111.212L817.649 133.941L819.53 130.411ZM816.59 105.81V132.176H820.59V105.81H816.59ZM817.65 107.576L860.327 130.305L862.207 126.775L819.53 104.045L817.65 107.576ZM820.59 132.176V105.81H816.59V132.176H820.59ZM862.207 153.141L819.53 130.411L817.65 133.942L860.327 156.671L862.207 153.141ZM859.267 128.54V154.906H863.267V128.54H859.267Z",
    fill: "black",
    mask: "url(#path-219-inside-20_3131_11627)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-221-inside-21_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.08 35.2894L796.403 22.6782L753.726 43.5892L777.403 56.2006L777.403 56.2004L820.08 78.9295L862.757 56.2002L820.08 35.2892L820.08 35.2894Z"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.08 35.2894L796.403 22.6782L753.726 43.5892L777.403 56.2006L777.403 56.2004L820.08 78.9295L862.757 56.2002L820.08 35.2892L820.08 35.2894Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M796.403 22.6782L797.343 20.913L796.441 20.4324L795.523 20.8822L796.403 22.6782ZM820.08 35.2894L819.139 37.0546L820.04 37.5341L820.956 37.0869L820.08 35.2894ZM753.726 43.5892L752.846 41.7932L749.332 43.5149L752.785 45.3544L753.726 43.5892ZM777.403 56.2006L776.462 57.9658L777.367 58.4476L778.286 57.9948L777.403 56.2006ZM777.403 56.2004L778.343 54.4351L777.439 53.9534L776.519 54.4062L777.403 56.2004ZM820.08 78.9295L819.14 80.6948L820.08 81.1955L821.02 80.6948L820.08 78.9295ZM862.757 56.2002L863.698 57.9654L867.151 56.126L863.637 54.4042L862.757 56.2002ZM820.08 35.2892L820.96 33.4932L820.082 33.063L819.203 33.4916L820.08 35.2892ZM795.463 24.4434L819.139 37.0546L821.02 33.5242L797.343 20.913L795.463 24.4434ZM754.606 45.3852L797.283 24.4742L795.523 20.8822L752.846 41.7932L754.606 45.3852ZM778.343 54.4354L754.666 41.824L752.785 45.3544L776.462 57.9658L778.343 54.4354ZM776.519 54.4062L776.519 54.4063L778.286 57.9948L778.286 57.9946L776.519 54.4062ZM821.02 77.1643L778.343 54.4351L776.463 57.9656L819.14 80.6948L821.02 77.1643ZM861.817 54.4349L819.14 77.1643L821.02 80.6948L863.698 57.9654L861.817 54.4349ZM819.2 37.0852L861.877 57.9962L863.637 54.4042L820.96 33.4932L819.2 37.0852ZM820.956 37.0869L820.957 37.0868L819.203 33.4916L819.203 33.4918L820.956 37.0869Z",
    fill: "black",
    mask: "url(#path-221-inside-21_3131_11627)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-223-inside-22_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.403 56.2003L754.226 44.0552V70.4212L777.402 82.5662V82.567L820.08 105.296V78.9303L777.403 56.2012V56.2003Z"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M777.403 56.2003L754.226 44.0552V70.4212L777.402 82.5662V82.567L820.08 105.296V78.9303L777.403 56.2012V56.2003Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M754.226 44.0552L755.154 42.2837L752.226 40.7492V44.0552H754.226ZM777.403 56.2003H779.403V54.9904L778.331 54.4288L777.403 56.2003ZM754.226 70.4212H752.226V71.6312L753.297 72.1927L754.226 70.4212ZM777.402 82.5662H779.402V81.3562L778.331 80.7946L777.402 82.5662ZM777.402 82.567H775.402V83.7678L776.462 84.3322L777.402 82.567ZM820.08 105.296L819.14 107.062L822.08 108.627V105.296H820.08ZM820.08 78.9303H822.08V77.7295L821.02 77.165L820.08 78.9303ZM777.403 56.2012H775.403V57.402L776.463 57.9664L777.403 56.2012ZM753.297 45.8267L776.475 57.9718L778.331 54.4288L755.154 42.2837L753.297 45.8267ZM756.226 70.4212V44.0552H752.226V70.4212H756.226ZM778.331 80.7946L755.154 68.6497L753.297 72.1927L776.474 84.3377L778.331 80.7946ZM779.402 82.567V82.5662H775.402V82.567H779.402ZM821.02 103.531L778.342 80.8017L776.462 84.3322L819.14 107.062L821.02 103.531ZM818.08 78.9303V105.296H822.08V78.9303H818.08ZM776.463 57.9664L819.14 80.6955L821.02 77.165L778.343 54.4359L776.463 57.9664ZM775.403 56.2003V56.2012H779.403V56.2003H775.403Z",
    fill: "black",
    mask: "url(#path-223-inside-22_3131_11627)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M861.758 81.9666V57.8665L821.08 79.5307V103.631L861.758 81.9666Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-226-inside-23_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.367 132.256L906.852 109.496L864.278 130.464L906.852 153.255L907.018 153.173L949.533 175.816L992.21 153.086L949.533 132.175L949.367 132.256Z"
  }))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.367 132.256L906.852 109.496L864.278 130.464L906.852 153.255L907.018 153.173L949.533 175.816L992.21 153.086L949.533 132.175L949.367 132.256Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M906.852 109.496L907.796 107.733L906.89 107.248L905.968 107.702L906.852 109.496ZM949.367 132.256L948.423 134.02L949.327 134.503L950.247 134.052L949.367 132.256ZM864.278 130.464L863.395 128.67L859.902 130.39L863.334 132.227L864.278 130.464ZM906.852 153.255L905.908 155.019L906.814 155.504L907.735 155.05L906.852 153.255ZM907.018 153.173L907.959 151.408L907.054 150.926L906.135 151.379L907.018 153.173ZM949.533 175.816L948.592 177.581L949.533 178.082L950.473 177.581L949.533 175.816ZM992.21 153.086L993.15 154.852L996.604 153.012L993.09 151.29L992.21 153.086ZM949.533 132.175L950.413 130.379L949.533 129.948L948.653 130.379L949.533 132.175ZM905.908 111.259L948.423 134.02L950.311 130.493L907.796 107.733L905.908 111.259ZM865.162 132.258L907.735 111.29L905.968 107.702L863.395 128.67L865.162 132.258ZM907.796 151.492L865.222 128.701L863.334 132.227L905.908 155.019L907.796 151.492ZM906.135 151.379L905.968 151.461L907.735 155.05L907.902 154.967L906.135 151.379ZM950.473 174.05L907.959 151.408L906.078 154.939L948.592 177.581L950.473 174.05ZM991.27 151.321L948.592 174.05L950.473 177.581L993.15 154.852L991.27 151.321ZM948.653 133.971L991.33 154.882L993.09 151.29L950.413 130.379L948.653 133.971ZM950.247 134.052L950.413 133.971L948.653 130.379L948.487 130.46L950.247 134.052Z",
    fill: "black",
    mask: "url(#path-226-inside-23_3131_11627)"
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-228-inside-24_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.854 153.087L864.177 130.357V156.723L906.854 179.453V153.087ZM949.532 175.816L906.854 153.086V179.452L949.532 202.182V175.816Z"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.854 153.087L864.177 130.357V156.723L906.854 179.453V153.087ZM949.532 175.816L906.854 153.086V179.452L949.532 202.182V175.816Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M864.177 130.357L865.117 128.592L862.177 127.026V130.357H864.177ZM906.854 153.087H908.854V151.886L907.794 151.321L906.854 153.087ZM864.177 156.723H862.177V157.924L863.237 158.488L864.177 156.723ZM906.854 179.453L905.914 181.218L908.854 182.784V179.453H906.854ZM906.854 153.086L907.795 151.321L904.854 149.755V153.086H906.854ZM949.532 175.816H951.532V174.615L950.472 174.051L949.532 175.816ZM906.854 179.452H904.854V180.653L905.914 181.218L906.854 179.452ZM949.532 202.182L948.592 203.947L951.532 205.513V202.182H949.532ZM863.237 132.122L905.914 154.852L907.794 151.321L865.117 128.592L863.237 132.122ZM866.177 156.723V130.357H862.177V156.723H866.177ZM907.794 177.687L865.117 154.958L863.237 158.488L905.914 181.218L907.794 177.687ZM904.854 153.087V179.453H908.854V153.087H904.854ZM905.914 154.852L948.592 177.581L950.472 174.051L907.795 151.321L905.914 154.852ZM908.854 179.452V153.086H904.854V179.452H908.854ZM950.472 200.417L907.795 177.687L905.914 181.218L948.592 203.947L950.472 200.417ZM947.532 175.816V202.182H951.532V175.816H947.532Z",
    fill: "black",
    mask: "url(#path-228-inside-24_3131_11627)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M991.209 178.852V154.752L950.531 176.416V200.516L991.209 178.852Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M597.683 46.7425L636.105 27.9772L674.527 46.7425V69.5196L636.105 89.8117L597.683 69.5196V46.7425Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M597.881 69.8253V47.9356L635.303 67.6996V89.5893L597.881 69.8253Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M674.727 69.8253V47.9356L637.304 67.6996V89.5893L674.727 69.8253Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M597.683 20.8782L636.105 2.11289L674.527 20.8782V43.6553L636.105 63.9474L597.683 43.6553V20.8782Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M597.881 43.9608V22.0711L635.303 41.8351V63.7248L597.881 43.9608Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M674.727 43.9608V22.0711L637.304 41.8351V63.7248L674.727 43.9608Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M202.604 28.0975L242.018 8.84776L281.432 28.0975V51.4785L242.018 72.2945L202.604 51.4785V28.0975Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M202.808 51.7919V29.2945L241.222 49.5823V72.0797L202.808 51.7919Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M281.637 51.7919V29.2945L243.223 49.5823V72.0797L281.637 51.7919Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M159.603 9.79925L239.292 50.3505V73.7398L199.878 94.5556L120.347 52.5042V28.9721L159.603 9.79925Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M120.218 52.2528V29.7605L199.081 71.8408V94.333L120.218 52.2528Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M239.495 74.0531V51.5558L201.081 71.8436V94.3409L239.495 74.0531Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M532.619 15.0495L610.328 54.5932V77.3786L571.906 97.6706L494.351 56.6642V33.7397L532.619 15.0495Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M494.226 56.419V34.5345L571.105 75.5558V97.4404L494.226 56.419Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M610.526 77.6842V55.7945L573.104 75.5585V97.4482L610.526 77.6842Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1111 9.79925L158.8 50.3505V73.7398L119.386 94.5556L39.8545 52.5042V28.9721L79.1111 9.79925Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7256 52.2528V29.7605L118.589 71.8408V94.333L39.7256 52.2528Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M159.003 74.0531V51.5558L120.589 71.8436V94.3409L159.003 74.0531Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M533.766 29.1917L572.188 10.4264L610.61 29.1917V51.9688L572.188 72.2609L533.766 51.9688V29.1917Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M533.964 52.2746V30.3849L571.386 50.1488V72.0385L533.964 52.2746Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M610.809 52.2746V30.3849L573.386 50.1488V72.0385L610.809 52.2746Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4453 23.3627L119.859 4.11289L159.274 23.3627V46.7437L119.859 67.5596L80.4453 46.7437V23.3627Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6484 47.057V24.5597L119.063 44.8475V67.3448L80.6484 47.057Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M159.478 47.057V24.5597L121.063 44.8475V67.3448L159.478 47.057Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-255-inside-25_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.899 726.945L704.383 704.185L661.81 725.153L704.383 747.944L704.55 747.862L747.064 770.504L789.741 747.775L747.064 726.864L746.899 726.945Z"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.899 726.945L704.383 704.185L661.81 725.153L704.383 747.944L704.55 747.862L747.064 770.504L789.741 747.775L747.064 726.864L746.899 726.945Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M704.383 704.185L705.327 702.421L704.421 701.936L703.499 702.39L704.383 704.185ZM746.899 726.945L745.955 728.708L746.858 729.192L747.779 728.741L746.899 726.945ZM661.81 725.153L660.926 723.358L657.433 725.078L660.866 726.916L661.81 725.153ZM704.383 747.944L703.439 749.707L704.345 750.192L705.267 749.738L704.383 747.944ZM704.55 747.862L705.49 746.096L704.585 745.615L703.666 746.068L704.55 747.862ZM747.064 770.504L746.124 772.269L747.064 772.77L748.004 772.269L747.064 770.504ZM789.741 747.775L790.682 749.54L794.135 747.701L790.621 745.979L789.741 747.775ZM747.064 726.864L747.944 725.068L747.064 724.637L746.184 725.068L747.064 726.864ZM703.439 705.948L745.955 728.708L747.842 725.182L705.327 702.421L703.439 705.948ZM662.693 726.947L705.267 705.979L703.499 702.39L660.926 723.358L662.693 726.947ZM705.327 746.181L662.754 723.389L660.866 726.916L703.439 749.707L705.327 746.181ZM703.666 746.068L703.499 746.15L705.267 749.738L705.433 749.656L703.666 746.068ZM748.004 768.739L705.49 746.096L703.61 749.627L746.124 772.269L748.004 768.739ZM788.801 746.01L746.124 768.739L748.004 772.269L790.682 749.54L788.801 746.01ZM746.184 728.66L788.861 749.571L790.621 745.979L747.944 725.068L746.184 728.66ZM747.779 728.741L747.944 728.66L746.184 725.068L746.019 725.149L747.779 728.741Z",
    fill: "black",
    mask: "url(#path-255-inside-25_3131_11627)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M705.386 773.541V749.44L746.063 771.105V795.205L705.386 773.541Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M662.708 750.811V726.711L703.385 748.375V772.475L662.708 750.811Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M788.74 773.541V749.44L748.063 771.105V795.205L788.74 773.541Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M867.302 102.208L907.824 82.3527L948.347 102.208L907.824 123.789L867.302 102.208Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M824.722 79.5856L865.125 59.6866L905.569 81.3379L865.166 101.237L824.722 79.5856Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M866.147 127.939V103.839L906.825 125.503V149.603L866.147 127.939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M823.47 105.209V81.1088L864.147 102.773V126.873L823.47 105.209Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M949.502 127.939V103.839L908.824 125.503V149.603L949.502 127.939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M289.558 541.859L330.08 522.004L370.603 541.859L330.08 563.44L289.558 541.859Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M246.978 519.236L287.381 499.337L327.825 520.989L287.422 540.888L246.978 519.236Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M288.403 567.59V543.49L329.081 565.154V589.254L288.403 567.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M245.726 544.86V520.76L286.403 542.424V566.524L245.726 544.86Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M371.758 567.59V543.49L331.08 565.154V589.254L371.758 567.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-270-inside-26_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.542 727.853L619.028 705.093L576.454 726.061L619.028 748.853L619.193 748.771L661.706 771.413L704.384 748.683L661.706 727.772L661.542 727.853Z"
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.542 727.853L619.028 705.093L576.454 726.061L619.028 748.853L619.193 748.771L661.706 771.413L704.384 748.683L661.706 727.772L661.542 727.853Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M619.028 705.093L619.972 703.33L619.066 702.845L618.144 703.299L619.028 705.093ZM661.542 727.853L660.598 729.616L661.502 730.1L662.422 729.649L661.542 727.853ZM576.454 726.061L575.57 724.267L572.078 725.987L575.51 727.824L576.454 726.061ZM619.028 748.853L618.084 750.616L618.989 751.101L619.911 750.647L619.028 748.853ZM619.193 748.771L620.133 747.006L619.229 746.524L618.31 746.977L619.193 748.771ZM661.706 771.413L660.766 773.178L661.706 773.679L662.647 773.178L661.706 771.413ZM704.384 748.683L705.324 750.449L708.778 748.609L705.264 746.887L704.384 748.683ZM661.706 727.772L662.586 725.976L661.706 725.545L660.826 725.976L661.706 727.772ZM618.084 706.856L660.598 729.616L662.486 726.09L619.972 703.33L618.084 706.856ZM577.338 727.855L619.911 706.887L618.144 703.299L575.57 724.267L577.338 727.855ZM619.971 747.089L577.398 724.298L575.51 727.824L618.084 750.616L619.971 747.089ZM618.31 746.977L618.144 747.058L619.911 750.647L620.077 750.565L618.31 746.977ZM662.647 769.648L620.133 747.006L618.253 750.536L660.766 773.178L662.647 769.648ZM703.444 746.918L660.766 769.648L662.647 773.178L705.324 750.449L703.444 746.918ZM660.826 729.568L703.504 750.479L705.264 746.887L662.586 725.976L660.826 729.568ZM662.422 729.649L662.586 729.568L660.826 725.976L660.662 726.057L662.422 729.649Z",
    fill: "black",
    mask: "url(#path-270-inside-26_3131_11627)"
  })), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-272-inside-27_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.029 748.684L576.352 725.955V752.321L619.029 775.05V748.684ZM661.707 771.413L619.029 748.684V775.05L661.707 797.779V771.413Z"
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.029 748.684L576.352 725.955V752.321L619.029 775.05V748.684ZM661.707 771.413L619.029 748.684V775.05L661.707 797.779V771.413Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M576.352 725.955L577.292 724.189L574.352 722.623V725.955H576.352ZM619.029 748.684H621.029V747.483L619.969 746.919L619.029 748.684ZM576.352 752.321H574.352V753.521L575.411 754.086L576.352 752.321ZM619.029 775.05L618.089 776.815L621.029 778.381V775.05H619.029ZM619.029 748.684L619.969 746.919L617.029 745.353V748.684H619.029ZM661.707 771.413H663.707V770.213L662.647 769.648L661.707 771.413ZM619.029 775.05H617.029V776.251L618.089 776.815L619.029 775.05ZM661.707 797.779L660.767 799.545L663.707 801.111V797.779H661.707ZM575.411 727.72L618.089 750.449L619.969 746.919L577.292 724.189L575.411 727.72ZM578.352 752.321V725.955H574.352V752.321H578.352ZM619.969 773.285L577.292 750.555L575.411 754.086L618.089 776.815L619.969 773.285ZM617.029 748.684V775.05H621.029V748.684H617.029ZM618.089 750.449L660.767 773.179L662.647 769.648L619.969 746.919L618.089 750.449ZM621.029 775.05V748.684H617.029V775.05H621.029ZM662.647 796.014L619.969 773.285L618.089 776.815L660.767 799.545L662.647 796.014ZM659.707 771.413V797.779H663.707V771.413H659.707Z",
    fill: "black",
    mask: "url(#path-272-inside-27_3131_11627)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M703.385 774.45V750.35L662.707 772.014V796.114L703.385 774.45Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M532.05 747.919L572.474 728.01L612.897 747.919L572.474 769.56L532.05 747.919Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M530.796 773.54V749.44L571.473 771.104V795.204L530.796 773.54Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M614.15 773.54V749.44L573.473 771.104V795.204L614.15 773.54Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M547.182 258.456L514.531 242.458L481.88 258.456L514.531 275.845L547.182 258.456Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M548.339 279.323V260.086L515.533 277.558V296.795L548.339 279.323Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M480.728 279.323V260.086L513.533 277.558V296.795L480.728 279.323Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M581.912 240.006L549.361 223.974L516.77 241.422L549.32 257.454L581.912 240.006Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M583.145 260.786V241.549L550.339 259.021V278.258L583.145 260.786Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M516.96 217.993L549.531 201.952L582.102 217.993L549.531 235.43L516.96 217.993Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M515.726 238.771V219.534L548.531 237.006V256.243L515.726 238.771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M583.339 238.771V219.534L550.533 237.006V256.243L583.339 238.771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 667.199L1147.08 647.29L1187.5 667.199L1147.08 688.839L1106.66 667.199Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 692.82V668.72L1146.08 690.385V714.485L1105.4 692.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 692.82V668.72L1148.08 690.385V714.485L1188.76 692.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 670.791L51.4033 650.881L91.8269 670.791L51.4033 692.431L10.9797 670.791Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 696.412V672.312L50.4031 693.976V718.076L9.72559 696.412Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 696.412V672.312L52.4026 693.976V718.076L93.0801 696.412Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 639.015L1147.08 619.106L1187.5 639.015L1147.08 660.655L1106.66 639.015Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 664.636V640.536L1146.08 662.2V686.3L1105.4 664.636Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 664.636V640.536L1148.08 662.2V686.3L1188.76 664.636Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 642.606L51.4033 622.697L91.8269 642.606L51.4033 664.247L10.9797 642.606Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 668.227V644.127L50.4031 665.791V689.891L9.72559 668.227Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 668.227V644.127L52.4026 665.791V689.891L93.0801 668.227Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 610.83L1147.08 590.921L1187.5 610.83L1147.08 632.471L1106.66 610.83Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 636.451V612.351L1146.08 634.015V658.115L1105.4 636.451Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 636.451V612.351L1148.08 634.015V658.115L1188.76 636.451Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 614.422L51.4033 594.512L91.8269 614.422L51.4033 636.062L10.9797 614.422Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 640.043V615.943L50.4031 637.607V661.707L9.72559 640.043Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 640.043V615.943L52.4026 637.607V661.707L93.0801 640.043Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 582.646L1147.08 562.737L1187.5 582.646L1147.08 604.287L1106.66 582.646Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 608.267V584.167L1146.08 605.831V629.931L1105.4 608.267Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 608.267V584.167L1148.08 605.831V629.931L1188.76 608.267Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 586.237L51.4033 566.328L91.8269 586.237L51.4033 607.877L10.9797 586.237Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 611.858V587.758L50.4031 609.422V633.522L9.72559 611.858Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 611.858V587.758L52.4026 609.422V633.522L93.0801 611.858Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 554.462L1147.08 534.552L1187.5 554.462L1147.08 576.102L1106.66 554.462Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 580.082V555.982L1146.08 577.647V601.747L1105.4 580.082Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 580.082V555.982L1148.08 577.647V601.747L1188.76 580.082Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 558.054L51.4033 538.145L91.8269 558.054L51.4033 579.694L10.9797 558.054Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 583.674V559.574L50.4031 581.238V605.339L9.72559 583.674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 583.674V559.574L52.4026 581.238V605.339L93.0801 583.674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 526.278L1147.08 506.369L1187.5 526.278L1147.08 547.918L1106.66 526.278Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 551.899V527.799L1146.08 549.463V573.563L1105.4 551.899Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 551.899V527.799L1148.08 549.463V573.563L1188.76 551.899Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 529.87L51.4033 509.961L91.8269 529.87L51.4033 551.51L10.9797 529.87Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 555.491V531.391L50.4031 553.055V577.155L9.72559 555.491Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 555.491V531.391L52.4026 553.055V577.155L93.0801 555.491Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 498.093L1147.08 478.184L1187.5 498.093L1147.08 519.733L1106.66 498.093Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 523.714V499.614L1146.08 521.278V545.378L1105.4 523.714Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 523.714V499.614L1148.08 521.278V545.378L1188.76 523.714Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 501.685L51.4033 481.776L91.8269 501.685L51.4033 523.325L10.9797 501.685Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 527.306V503.205L50.4031 524.87V548.97L9.72559 527.306Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 527.306V503.205L52.4026 524.87V548.97L93.0801 527.306Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 469.909L1147.08 450L1187.5 469.909L1147.08 491.55L1106.66 469.909Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 495.53V471.43L1146.08 493.094V517.194L1105.4 495.53Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 495.53V471.43L1148.08 493.094V517.194L1188.76 495.53Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 473.5L51.4033 453.591L91.8269 473.5L51.4033 495.141L10.9797 473.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 499.121V475.021L50.4031 496.685V520.785L9.72559 499.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 499.121V475.021L52.4026 496.685V520.785L93.0801 499.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 441.725L1147.08 421.816L1187.5 441.725L1147.08 463.365L1106.66 441.725Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 467.345V443.245L1146.08 464.91V489.01L1105.4 467.345Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 467.345V443.245L1148.08 464.91V489.01L1188.76 467.345Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 445.316L51.4033 425.406L91.8269 445.316L51.4033 466.956L10.9797 445.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 470.936V446.836L50.4031 468.5V492.6L9.72559 470.936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 470.936V446.836L52.4026 468.5V492.6L93.0801 470.936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 413.54L1147.08 393.631L1187.5 413.54L1147.08 435.18L1106.66 413.54Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 439.161V415.061L1146.08 436.725V460.825L1105.4 439.161Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 439.161V415.061L1148.08 436.725V460.825L1188.76 439.161Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 417.131L51.4033 397.222L91.8269 417.131L51.4033 438.772L10.9797 417.131Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 442.752V418.652L50.4031 440.316V464.416L9.72559 442.752Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 442.752V418.652L52.4026 440.316V464.416L93.0801 442.752Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 385.355L1147.08 365.446L1187.5 385.355L1147.08 406.996L1106.66 385.355Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 410.976V386.876L1146.08 408.54V432.64L1105.4 410.976Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 410.976V386.876L1148.08 408.54V432.64L1188.76 410.976Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 388.946L51.4033 369.037L91.8269 388.946L51.4033 410.587L10.9797 388.946Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 414.568V390.467L50.4031 412.132V436.232L9.72559 414.568Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 414.568V390.467L52.4026 412.132V436.232L93.0801 414.568Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 357.171L1147.08 337.262L1187.5 357.171L1147.08 378.811L1106.66 357.171Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 382.792V358.692L1146.08 380.356V404.456L1105.4 382.792Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 382.792V358.692L1148.08 380.356V404.456L1188.76 382.792Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 360.763L51.4033 340.854L91.8269 360.763L51.4033 382.403L10.9797 360.763Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 386.384V362.284L50.4031 383.948V408.048L9.72559 386.384Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 386.384V362.284L52.4026 383.948V408.048L93.0801 386.384Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 328.987L1147.08 309.077L1187.5 328.987L1147.08 350.627L1106.66 328.987Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 354.607V330.507L1146.08 352.172V376.272L1105.4 354.607Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 354.607V330.507L1148.08 352.172V376.272L1188.76 354.607Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 300.731L1147.08 280.822L1187.5 300.731L1147.08 322.371L1106.66 300.731Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 326.352V302.252L1146.08 323.916V348.016L1105.4 326.352Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 326.352V302.252L1148.08 323.916V348.016L1188.76 326.352Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 332.578L51.4033 312.669L91.8269 332.578L51.4033 354.218L10.9797 332.578Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 358.199V334.099L50.4031 355.763V379.863L9.72559 358.199Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 358.199V334.099L52.4026 355.763V379.863L93.0801 358.199Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 304.422L51.4033 284.513L91.8269 304.422L51.4033 326.062L10.9797 304.422Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 330.043V305.943L50.4031 327.607V351.707L9.72559 330.043Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 330.043V305.943L52.4026 327.607V351.707L93.0801 330.043Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 271.709L1147.08 251.8L1187.5 271.709L1147.08 293.349L1106.66 271.709Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 297.329V273.229L1146.08 294.893V318.993L1105.4 297.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 297.329V273.229L1148.08 294.893V318.993L1188.76 297.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 276.237L51.4033 256.328L91.8269 276.237L51.4033 297.878L10.9797 276.237Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 301.858V277.758L50.4031 299.423V323.523L9.72559 301.858Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 301.858V277.758L52.4026 299.423V323.523L93.0801 301.858Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.66 243.552L1147.08 223.643L1187.5 243.552L1147.08 265.193L1106.66 243.552Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.4 269.173V245.073L1146.08 266.737V290.838L1105.4 269.173Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.76 269.173V245.073L1148.08 266.737V290.838L1188.76 269.173Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9797 248.081L51.4033 228.172L91.8269 248.081L51.4033 269.722L10.9797 248.081Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 273.702V249.602L50.4031 271.266V295.366L9.72559 273.702Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0801 273.702V249.602L52.4026 271.266V295.366L93.0801 273.702Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M211.98 546.148L252.403 526.239L292.827 546.148L252.403 567.789L211.98 546.148Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M210.726 571.769V547.669L251.403 569.333V593.433L210.726 571.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M294.08 571.769V547.669L253.403 569.333V593.433L294.08 571.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M211.98 518.148L252.403 498.239L292.827 518.148L252.403 539.789L211.98 518.148Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M210.726 543.769V519.669L251.403 541.333V565.433L210.726 543.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M294.08 543.769V519.669L253.403 541.333V565.433L294.08 543.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 490.592L251.821 470.683L292.245 490.592L251.821 512.233L211.398 490.592Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 516.213V492.113L250.821 513.777V537.877L210.144 516.213Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 516.213V492.113L252.821 513.777V537.877L293.498 516.213Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 462.407L251.821 442.498L292.245 462.407L251.821 484.048L211.398 462.407Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 488.028V463.928L250.821 485.592V509.692L210.144 488.028Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 488.028V463.928L252.821 485.592V509.692L293.498 488.028Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 434.224L251.821 414.315L292.245 434.224L251.821 455.864L211.398 434.224Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 459.845V435.744L250.821 457.409V481.509L210.144 459.845Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 459.845V435.744L252.821 457.409V481.509L293.498 459.845Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 405.102L251.821 385.193L292.245 405.102L251.821 426.743L211.398 405.102Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 430.723V406.623L250.821 428.287V452.387L210.144 430.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 430.723V406.623L252.821 428.287V452.387L293.498 430.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 376.918L251.821 357.008L292.245 376.918L251.821 398.558L211.398 376.918Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 402.539V378.439L250.821 400.103V424.203L210.144 402.539Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 402.539V378.439L252.821 400.103V424.203L293.498 402.539Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 348.733L251.821 328.824L292.245 348.733L251.821 370.373L211.398 348.733Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 374.354V350.254L250.821 371.918V396.018L210.144 374.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 374.354V350.254L252.821 371.918V396.018L293.498 374.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 320.549L251.821 300.639L292.245 320.549L251.821 342.189L211.398 320.549Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 346.169V322.069L250.821 343.734V367.834L210.144 346.169Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 346.169V322.069L252.821 343.734V367.834L293.498 346.169Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 292.364L251.821 272.455L292.245 292.364L251.821 314.005L211.398 292.364Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 317.985V293.885L250.821 315.549V339.65L210.144 317.985Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 317.985V293.885L252.821 315.549V339.65L293.498 317.985Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 264.18L251.821 244.271L292.245 264.18L251.821 285.82L211.398 264.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 289.8V265.7L250.821 287.364V311.465L210.144 289.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 289.8V265.7L252.821 287.364V311.465L293.498 289.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M211.398 236.024L251.821 216.114L292.245 236.024L251.821 257.664L211.398 236.024Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M210.144 261.645V237.544L250.821 259.209V283.309L210.144 261.645Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M293.498 261.645V237.544L252.821 259.209V283.309L293.498 261.645Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M802.726 41.468L844.403 21.1129L886.081 41.468V66.2272L844.403 88.2385L802.726 66.2272V41.468Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M802.94 66.5581V42.6742L843.618 64.1573V88.0412L802.94 66.5581Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M886.295 66.5581V42.6742L845.617 64.1573V88.0412L886.295 66.5581Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M865.727 100.712V76.6121L906.404 98.2763V122.376L865.727 100.712Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-422-inside-28_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.568 54.1161L950.084 31.3555L992.657 52.3234L950.084 75.1147L949.918 75.033L907.403 97.6758L864.725 74.9464L907.403 54.0354L907.568 54.1161Z"
  }))), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.568 54.1161L950.084 31.3555L992.657 52.3234L950.084 75.1147L949.918 75.033L907.403 97.6758L864.725 74.9464L907.403 54.0354L907.568 54.1161Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M950.084 31.3555L949.14 29.5922L950.046 29.1073L950.967 29.5613L950.084 31.3555ZM907.568 54.1161L908.511 55.8793L907.608 56.363L906.688 55.9121L907.568 54.1161ZM992.657 52.3234L993.541 50.5293L997.033 52.2493L993.601 54.0867L992.657 52.3234ZM950.084 75.1147L951.028 76.878L950.122 77.3629L949.2 76.9089L950.084 75.1147ZM949.918 75.033L948.978 73.2677L949.882 72.786L950.801 73.2388L949.918 75.033ZM907.403 97.6758L908.343 99.441L907.403 99.9417L906.463 99.441L907.403 97.6758ZM864.725 74.9464L863.785 76.7117L860.331 74.8722L863.845 73.1504L864.725 74.9464ZM907.403 54.0354L906.523 52.2394L907.403 51.8082L908.283 52.2394L907.403 54.0354ZM951.028 33.1187L908.511 55.8793L906.624 52.3529L949.14 29.5922L951.028 33.1187ZM991.774 54.1176L949.2 33.1497L950.967 29.5613L993.541 50.5293L991.774 54.1176ZM949.14 73.3515L991.713 50.5602L993.601 54.0867L951.028 76.878L949.14 73.3515ZM950.801 73.2388L950.967 73.3205L949.2 76.9089L949.034 76.8272L950.801 73.2388ZM906.463 95.9105L948.978 73.2677L950.858 76.7982L908.343 99.441L906.463 95.9105ZM865.666 73.1812L908.343 95.9105L906.463 99.441L863.785 76.7117L865.666 73.1812ZM908.283 55.8314L865.605 76.7424L863.845 73.1504L906.523 52.2394L908.283 55.8314ZM906.688 55.9121L906.523 55.8314L908.283 52.2394L908.448 52.3201L906.688 55.9121Z",
    fill: "black",
    mask: "url(#path-422-inside-28_3131_11627)"
  })), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-424-inside-29_3131_11627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M950.081 74.9466L992.759 52.2173V78.5833L950.081 101.313V74.9466ZM907.404 97.6759L950.081 74.9465V101.313L907.404 124.042V97.6759Z"
  }))), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M950.081 74.9466L992.759 52.2173V78.5833L950.081 101.313V74.9466ZM907.404 97.6759L950.081 74.9465V101.313L907.404 124.042V97.6759Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M992.759 52.2173L991.819 50.452L994.759 48.8862V52.2173H992.759ZM950.081 74.9466H948.081V73.7458L949.141 73.1814L950.081 74.9466ZM992.759 78.5833H994.759V79.7841L993.699 80.3486L992.759 78.5833ZM950.081 101.313L951.021 103.078L948.081 104.644V101.313H950.081ZM950.081 74.9465L949.141 73.1813L952.081 71.6154V74.9465H950.081ZM907.404 97.6759H905.404V96.4751L906.463 95.9106L907.404 97.6759ZM950.081 101.313H952.081V102.513L951.021 103.078L950.081 101.313ZM907.404 124.042L908.344 125.807L905.404 127.373V124.042H907.404ZM993.699 53.9825L951.021 76.7119L949.141 73.1814L991.819 50.452L993.699 53.9825ZM990.759 78.5833V52.2173H994.759V78.5833H990.759ZM949.141 99.5474L991.819 76.8181L993.699 80.3486L951.021 103.078L949.141 99.5474ZM952.081 74.9466V101.313H948.081V74.9466H952.081ZM951.021 76.7118L908.344 99.4411L906.463 95.9106L949.141 73.1813L951.021 76.7118ZM948.081 101.313V74.9465H952.081V101.313H948.081ZM906.463 122.277L949.141 99.5473L951.021 103.078L908.344 125.807L906.463 122.277ZM909.404 97.6759V124.042H905.404V97.6759H909.404Z",
    fill: "black",
    mask: "url(#path-424-inside-29_3131_11627)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M439.726 46.7425L478.148 27.9772L516.57 46.7425V69.5196L478.148 89.8117L439.726 69.5196V46.7425Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M439.924 69.8253V47.9356L477.346 67.6996V89.5893L439.924 69.8253Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M516.77 69.8253V47.9356L479.347 67.6996V89.5893L516.77 69.8253Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M575.98 721.148L616.403 701.239L656.827 721.148L616.403 742.789L575.98 721.148Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M574.726 746.769V722.669L615.403 744.333V768.433L574.726 746.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M658.08 746.769V722.669L617.403 744.333V768.433L658.08 746.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarbleWorldContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarbleWorldContrast.5b8ba79d66d72214ebb68fb2e6a23e94.svg";